import ConfiguracionEmpresa from './ConfiguracionEmpresa';
import TipoCambio from './TipoCambio';
import UbigeoManager from './UbigeoManager';
import Sucursales from './Sucursales';
import Almacenes from './Almacenes';
import SeriesSucursal from './SeriesSucursal';
import PermisosUsuario from './PermisosUsuario';
import Series from './Series';
import TipoDocumento from './TipoDocumento';
// import TipoCambio from './TipoCambio';
import TipoDocumentoIdentidad from './TipoDocumentoIdentidad';
import Auxiliares from './Auxiliares';
import CondicionPago from './CondicionPago';
import React from 'react';
import axios from 'axios';
// Iconos MUI profesionales
import HomeIcon from '@mui/icons-material/Home';
import SettingsIcon from '@mui/icons-material/Settings';
import StoreIcon from '@mui/icons-material/Store';
import BusinessIcon from '@mui/icons-material/Business';
import CategoryIcon from '@mui/icons-material/Category';
import ColorLensIcon from '@mui/icons-material/ColorLens';
import PaymentIcon from '@mui/icons-material/Payment';
import PeopleIcon from '@mui/icons-material/People';
import CurrencyExchangeIcon from '@mui/icons-material/CurrencyExchange';
import LockPersonIcon from '@mui/icons-material/Lock';
import ReceiptIcon from '@mui/icons-material/Receipt';
import ListAltIcon from '@mui/icons-material/ListAlt';
// import InventoryIcon from '@material-ui/icons/Inventory';
import CompareArrowsIcon from '@mui/icons-material/CompareArrows';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import StraightenIcon from '@mui/icons-material/Straighten';
import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import MapIcon from '@mui/icons-material/Map';
import LayersIcon from '@mui/icons-material/Layers';
import NumbersIcon from '@mui/icons-material/LooksOne';
import DocumentScannerIcon from '@mui/icons-material/Scanner';
import DraftsIcon from '@mui/icons-material/Drafts';
import PointOfSaleIcon from '@mui/icons-material/PointOfSale';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import CallMadeIcon from '@mui/icons-material/CallMade';
import LocalShippingIcon from '@mui/icons-material/LocalShipping';
import ShoppingCartIcon from '@mui/icons-material/ShoppingCart';
import Inventory2Icon from '@mui/icons-material/Inventory2';
import AccountBalanceWalletIcon from '@mui/icons-material/AccountBalanceWallet';
import AccountBalanceIcon from '@mui/icons-material/AccountBalance';
import AccountTreeIcon from '@mui/icons-material/AccountTree';
import CalendarMonthIcon from '@mui/icons-material/CalendarMonth';
import ReceiptLongIcon from '@mui/icons-material/ReceiptLong';
import AssessmentIcon from '@mui/icons-material/Assessment';
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh';
import DescriptionIcon from '@mui/icons-material/Description';
import LocalAtmIcon from '@mui/icons-material/LocalAtm';
import MenuBookIcon from '@mui/icons-material/MenuBook';
import CloudDownloadIcon from '@mui/icons-material/CloudDownload';
import LockIcon from '@mui/icons-material/Lock';
import Usuarios from './Usuarios';
import { Box, Typography, Drawer, List, ListItem, ListItemIcon, ListItemText, AppBar, Toolbar, IconButton, Collapse, useMediaQuery, useTheme, Avatar } from '@mui/material';
import { obtenerEmpresaConfig } from '../utils/empresaConfig';
import { setFaviconFromLogo } from '../utils/favicon';
import MenuIcon from '@mui/icons-material/Menu';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';
import DashboardIcon from '@mui/icons-material/Dashboard';
import ManageSearchIcon from '@mui/icons-material/ManageSearch';
import LogoutIcon from '@mui/icons-material/ExitToApp';
import NotificationsIcon from '@mui/icons-material/Notifications';
import AdminPanelSettingsIcon from '@mui/icons-material/AdminPanelSettings';
import NotificationsNoneIcon from '@mui/icons-material/NotificationsNone';
import WarningAmberIcon from '@mui/icons-material/WarningAmber';
import ErrorOutlineIcon from '@mui/icons-material/ErrorOutline';
import { Alert, Badge, Button, Card, CardContent, Chip, CircularProgress, Divider, Grid, Paper, Popover, Stack, Tab, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, Tabs, Dialog, DialogTitle, DialogContent, DialogActions, TextField } from '@mui/material';
import HistoryIcon from '@mui/icons-material/History';
import UndoIcon from '@mui/icons-material/Undo';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import VisibilityIcon from '@mui/icons-material/Visibility';
import { BarChart, Bar, LineChart, Line, XAxis, YAxis, CartesianGrid, Tooltip, Legend, ResponsiveContainer } from 'recharts';
import Categorias from './Categorias';
import Subcategorias from './Subcategorias';
import Marcas from './Marcas';
import Modelos from './Modelos';
import Tallas from './Tallas';
import Colores from './Colores';
import Unidades from './Unidades';
import Conversiones from './Conversiones';
import Productos from './Productos';
import CotizacionPage from './Cotizacion';
import NotaVentaPage from './NotaVenta';
import FacturaPage from './Factura';
import BoletaVentaPage from './BoletaVenta';
import NotaCreditoPage from './NotaCredito';
import NotadebitoPage from './NotaDebito';
import PlantillasPdf from './PlantillasPdf';
import GuiaRemisionPage from './GuiaRemision';
import GuiaRemisionTransportistaPage from './GuiaRemisionTransportista';
import ChoferesPage from './Choferes';
import VehiculosPage from './Vehiculos';
import TransportistasPage from './Transportistas';
import RequerimientoPage from './Requerimiento';
import OrdenCompraPage from './OrdenCompra';
import CompraPage from './Compra';
import NotaCreditoCompraPage from './NotaCreditoCompra';
import KardexPage from './Kardex';
import TesoreriaPage from './Tesoreria';
import CajaChicaPage from './CajaChica';
import ManualPage from './Manual';
import ControlComprobantes from './ControlComprobantes';
import ReimprimirXmlPage from './ReimprimirXml';
import AdminVentasPage from './AdminVentas';
import AdminComprasPage from './AdminCompras';
import VentaRapidaPage from './VentaRapida';
import EmpresasContables from './contabilidad/EmpresasContables';
import PlanContable from './contabilidad/PlanContable';
import Periodos from './contabilidad/Periodos';
import Asientos from './contabilidad/Asientos';
import ReportesContables from './contabilidad/ReportesContables';
import AsientoRapidoConfig from './contabilidad/AsientoRapidoConfig';
import Ple from './contabilidad/Ple';
import SireVentas from './SireVentas';
import SireCompras from './SireCompras';
import SireVentasDeclaracion from './SireVentasDeclaracion';
import SireComprasDeclaracion from './SireComprasDeclaracion';
import RegistroVentas from './contabilidad/RegistroVentas';
import RegistroCompras from './contabilidad/RegistroCompras';
import ArqueoCaja from './contabilidad/ArqueoCaja';
import ImportadorSire from './contabilidad/ImportadorSire';
import CierreContable from './contabilidad/CierreContable';
import CentrosCosto from './contabilidad/CentrosCosto';
import ConciliacionBancaria from './contabilidad/ConciliacionBancaria';
import ActivosFijos from './contabilidad/ActivosFijos';
import Presupuesto from './contabilidad/Presupuesto';
import AgingCuentas from './contabilidad/AgingCuentas';
import Retenciones from './contabilidad/Retenciones';
import DashboardContable from './contabilidad/DashboardContable';
import SeleccionarEmpresaContable from './contabilidad/SeleccionarEmpresaContable';
import { useEmpresaActiva } from '../context/EmpresaContableContext';
import Pdt0621 from './contabilidad/Pdt0621';
import AnalisisCuenta from './contabilidad/AnalisisCuenta';
import EstadoFlujosCash from './contabilidad/EstadoFlujosCash';
import UrcClasificacion from './contabilidad/UrcClasificacion';
import RubroEeffClasificacion from './contabilidad/RubroEeffClasificacion';
import AuxiliaresContable from './contabilidad/AuxiliaresContable';
import DashboardRRHH from './rrhh/DashboardRRHH';
import EmpresasRRHH from './rrhh/EmpresasRRHH';
import TrabajadoresPage from './rrhh/Trabajadores';
import PlanillaRRHH from './rrhh/PlanillaRRHH';
import CtsPage from './rrhh/CTS';
import GratificacionesPage from './rrhh/Gratificaciones';
import VacacionesPage from './rrhh/Vacaciones';
import AsistenciaPage from './rrhh/Asistencia';
import ReportesRRHH from './rrhh/ReportesRRHH';
import PrestamosPage from './rrhh/Prestamos';
import LiquidacionPage from './rrhh/LiquidacionRRHH';
import AdelantosPage from './rrhh/AdelantosRRHH';
import FeriadosPage from './rrhh/FeriadosRRHH';
import SeguroVidaPage from './rrhh/SeguroVidaRRHH';
import RxhPage from './rrhh/RxhRRHH';
import BadgeIcon from '@mui/icons-material/Badge';
import GroupsIcon from '@mui/icons-material/Groups';
import PaymentsIcon from '@mui/icons-material/Payments';
import SavingsIcon from '@mui/icons-material/Savings';
import BeachAccessIcon from '@mui/icons-material/BeachAccess';
import CardGiftcardIcon from '@mui/icons-material/CardGiftcard';
import AccessTimeIcon from '@mui/icons-material/AccessTime';
import GavelIcon from '@mui/icons-material/Gavel';
import MoneyOffIcon from '@mui/icons-material/MoneyOff';
import HealthAndSafetyIcon from '@mui/icons-material/HealthAndSafety';
import LabelIcon from '@mui/icons-material/Label';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import EmailIcon from '@mui/icons-material/Email';
import ConfiguracionWhatsApp from './ConfiguracionWhatsApp';
import ConfiguracionEmail from './ConfiguracionEmail';
import RecetasPage from './Recetas';
import OrdenProduccionPage from './OrdenProduccion';
import ImportacionPage from './Importacion';
import ScienceIcon from '@mui/icons-material/Science';
import FactoryIcon from '@mui/icons-material/Factory';

const menuItems = [
  { text: 'Inicio', icon: <DashboardIcon /> },
  { text: 'Facturación', icon: <ReceiptIcon /> },
  { text: 'Pagos', icon: <ReceiptIcon /> },
  { text: 'Clientes', icon: <ReceiptIcon /> },
  { text: 'Proveedores', icon: <ReceiptIcon /> },
  { text: 'Inventario', icon: <StoreIcon /> },
  {
    text: 'Mantenimiento',
    icon: <DashboardIcon />,
    subItems: [
      // { text: 'Tipo de Cambio', icon: <ReceiptIcon /> },
    ]
  },
];

const currencyFormatter = new Intl.NumberFormat('es-PE', {
  style: 'currency',
  currency: 'PEN',
  minimumFractionDigits: 0,
  maximumFractionDigits: 0,
});

const numberFormatter = new Intl.NumberFormat('es-PE');

const monthLabelFormatter = new Intl.DateTimeFormat('es-PE', {
  month: 'short',
  year: '2-digit',
});

const DASHBOARD_DEFAULT = {
  resumen: {
    ventasMesActual: 0,
    ventasMesAnterior: 0,
    ventasAnioActual: 0,
    comprobantesMesActual: 0,
    clientesActivosMesActual: 0,
    ticketPromedioMesActual: 0,
    variacionMensual: 0,
    guiasMesActual: 0,
    guiasRemitenteMesActual: 0,
    guiasTransportistaMesActual: 0,
    pendientesSunat: 0,
  },
  series: {
    ventasMensuales: [],
    documentosPorTipo: [],
    estadosSunat: [],
    topClientes: [],
  },
  exploracion: {
    ventasDiarias: [],
    topProductos: [],
    clientes: [],
    vendedores: [],
    embudo: {
      cotizaciones: 0,
      notasVenta: 0,
      comprobantes: 0,
      aceptadosSunat: 0,
      montoCotizaciones: 0,
    },
  },
  meta: {
    comprasDisponibles: false,
    modulosFuturos: [],
    generadoEn: null,
  },
  compras: { mesMonto: 0, mesCount: 0 },
  tesoreria: { cobros_pendientes: 0, pagos_pendientes: 0, cobros_cobrados: 0, cobros_count: 0, pagos_count: 0, balance: 0 },
};

const CLIENTE_DETALLE_DEFAULT = {
  clienteId: null,
  cliente: '',
  numeroDocumento: '',
  resumen: {
    documentos: 0,
    total: 0,
    ticketPromedio: 0,
    ultimaCompra: null,
  },
  topProductos: [],
  operaciones: [],
};

const TIPO_COMPROBANTE_LABELS = {
  '01': 'Facturas',
  '03': 'Boletas',
  '07': 'Notas Crédito',
  '08': 'Notas Débito',
};

// Etiquetas legibles para el detalle/historial del panel de Notificaciones.
const NOTIF_FIELD_LABEL = {
  id: 'ID', codigo: 'Código', nombre: 'Producto', stock: 'Stock', minimo: 'Stock mínimo',
  doc: 'Documento', estado: 'Estado', fecha: 'Fecha', cliente: 'Cliente', proveedor: 'Proveedor',
  pendiente: 'Monto pendiente', vence: 'Vence', tipo_documento: 'Tipo documento',
  documento_id: 'Documento N°', producto: 'Producto', mensaje: 'Mensaje de error',
};
const NOTIF_CATEGORIA_LABEL = {
  stock_agotado: 'Stock agotado', stock_bajo: 'Stock bajo mínimo',
  cpe_error: 'CPE error/rechazado', cpe_pendiente: 'CPE pendiente de envío',
  cobros_vencidos: 'Cobro vencido', pagos_vencidos: 'Pago vencido',
  cobros_proximos: 'Cobro próximo', pagos_proximos: 'Pago próximo',
  cotizaciones_antiguas: 'Cotización sin convertir', kardex_errores: 'Kardex sin registrar',
  anulacion_error: 'Error de anulación (Baja)',
  guia_error: 'Guía con error/rechazada',
};

const ESTADO_COLOR = {
  ACEPTADO: '#2e7d32',
  RECHAZADO: '#c62828',
  ENVIADO: '#1565c0',
  PENDIENTE: '#ef6c00',
  PROCESANDO: '#6a1b9a',
  PREPARADO: '#00838f',
};

const formatCurrency = (value) => currencyFormatter.format(Number(value || 0));
const formatNumber = (value) => numberFormatter.format(Number(value || 0));
const formatDateShort = (value) => {
  if (!value) return '-';
  const date = new Date(value);
  if (Number.isNaN(date.getTime())) return String(value).slice(0, 10);
  return date.toLocaleDateString('es-PE');
};
// Reformatea fechas ISO (YYYY-MM-DD o YYYY-MM-DD HH:MM) a DD/MM/YYYY [HH:MM],
// el formato que usa el resto del sistema — evita mostrar fechas "en inglés"
// (orden año-mes-día) en el panel de notificaciones. Split manual en vez de
// `new Date(...).toLocaleDateString()` para no arrastrar el bug de desfase
// de un día por zona horaria (UTC medianoche vs. hora local Perú UTC-5).
const fmtFechaISO = (value) => {
  if (!value) return '';
  const m = String(value).match(/^(\d{4})-(\d{2})-(\d{2})(?:[ T](\d{2}:\d{2}))?/);
  if (!m) return String(value);
  return m[4] ? `${m[3]}/${m[2]}/${m[1]} ${m[4]}` : `${m[3]}/${m[2]}/${m[1]}`;
};

const formatMonthLabel = ({ anio, mes }) => {
  if (!anio || !mes) return '';
  return monthLabelFormatter.format(new Date(anio, mes - 1, 1)).replace('.', '');
};

// Accesos directos del "Panel de inicio" simplificado (sin cifras) para usuarios
// a quienes se les restringió el módulo 'panel_inicio'. Cada botón navega al
// mismo destino que su ítem equivalente en el menú lateral, agrupados en
// secciones (igual que el menú) en vez de una tarjeta genérica por módulo.
// Se dejan fuera SIRE Ventas/Compras y Plantillas PDF (trámite tributario /
// configuración, no documentos de uso diario). Contabilidad y RR.HH. se
// resumen a su Dashboard respectivo porque cada uno tiene 15+ subopciones
// en el menú y listarlas todas saturaría la pantalla.
const SECCIONES_ACCESO_DIRECTO = [
  {
    modulo: 'facturacion', label: 'Facturación', icon: <ReceiptIcon color="success" />,
    items: [
      { label: 'Cotización', page: 'cotizaciones', icon: <ListAltIcon fontSize="small" color="primary" /> },
      { label: 'Nota de Venta', page: 'notaVenta', icon: <DraftsIcon fontSize="small" color="secondary" /> },
      { label: 'Boleta', page: 'boleta', icon: <PointOfSaleIcon fontSize="small" color="success" /> },
      { label: 'Factura', page: 'factura', icon: <ReceiptIcon fontSize="small" color="info" /> },
      { label: 'Nota de Crédito', page: 'notaCredito', icon: <CreditCardIcon fontSize="small" color="warning" /> },
      { label: 'Nota de Débito', page: 'notaDebito', icon: <CallMadeIcon fontSize="small" color="error" /> },
      { label: 'Guía Remitente', page: 'guiaRemision', icon: <LocalShippingIcon fontSize="small" color="primary" /> },
      { label: 'Guía Transportista', page: 'guiaTransportista', icon: <LocalShippingIcon fontSize="small" color="secondary" /> },
      { label: 'Venta Rápida', page: 'ventaRapida', icon: <PointOfSaleIcon fontSize="small" color="primary" /> },
      { label: 'Centro de Ventas', page: 'adminVentas', icon: <ReceiptIcon fontSize="small" color="warning" /> },
    ],
  },
  {
    modulo: 'logistica', label: 'Compras / Logística', icon: <ShoppingCartIcon color="warning" />,
    items: [
      { label: 'Requerimientos', page: 'requerimiento', icon: <DescriptionIcon fontSize="small" color="warning" /> },
      { label: 'Órdenes de Compra', page: 'orden_compra', icon: <ListAltIcon fontSize="small" color="warning" /> },
      { label: 'Registro de Compras', page: 'compras', icon: <ShoppingCartIcon fontSize="small" color="primary" /> },
      { label: 'NC de Compras', page: 'nc_compra', icon: <ShoppingCartIcon fontSize="small" color="error" /> },
      { label: 'Kardex de Inventario', page: 'kardex', icon: <Inventory2Icon fontSize="small" color="success" /> },
      { label: 'Centro de Compras', page: 'adminCompras', icon: <ShoppingCartIcon fontSize="small" color="warning" /> },
    ],
  },
  {
    modulo: 'tesoreria', label: 'Tesorería', icon: <AccountBalanceWalletIcon color="info" />,
    items: [{ label: 'Tesorería', page: 'tesoreria', icon: <AccountBalanceWalletIcon fontSize="small" color="info" /> }],
  },
  {
    modulo: 'cajaChica', label: 'Caja Chica', icon: <LocalAtmIcon color="warning" />,
    items: [{ label: 'Caja Chica', page: 'caja_chica', icon: <LocalAtmIcon fontSize="small" color="warning" /> }],
  },
  {
    modulo: 'produccion', label: 'Producción', icon: <FactoryIcon color="secondary" />,
    items: [
      { label: 'Recetas / BOM', page: 'recetas', icon: <ScienceIcon fontSize="small" color="secondary" /> },
      { label: 'Órdenes de Producción', page: 'orden_produccion', icon: <FactoryIcon fontSize="small" color="primary" /> },
    ],
  },
  {
    modulo: 'importacion', label: 'Importaciones', icon: <LocalShippingIcon color="warning" />,
    items: [{ label: 'Importaciones', page: 'importacion', icon: <LocalShippingIcon fontSize="small" color="warning" /> }],
  },
  {
    modulo: 'activoFijo', label: 'Activos Fijos', icon: <Inventory2Icon color="info" />,
    items: [{ label: 'Activos Fijos', page: 'cont_activos_fijos', icon: <Inventory2Icon fontSize="small" color="info" /> }],
  },
  {
    modulo: 'mantenimiento', label: 'Mantenimiento', icon: <SettingsIcon color="secondary" />,
    items: [{ label: 'Mantenimiento', page: 'almacenes', icon: <SettingsIcon fontSize="small" color="secondary" /> }],
  },
  {
    modulo: 'contabilidad', label: 'Contabilidad', icon: <AccountBalanceIcon color="secondary" />,
    items: [{ label: 'Dashboard Contabilidad', page: 'cont_dashboard', icon: <AccountBalanceIcon fontSize="small" color="secondary" /> }],
  },
  {
    modulo: 'rrhh', label: 'Recursos Humanos', icon: <BadgeIcon sx={{ color: '#7b1fa2' }} />,
    items: [{ label: 'Dashboard RR.HH.', page: 'rrhh_dashboard', icon: <BadgeIcon fontSize="small" sx={{ color: '#7b1fa2' }} /> }],
  },
];

function PanelInicioBienvenida({ logoEmpresa, nombreUsuario, secciones, onNavigate }) {
  const horaActual = new Date().getHours();
  const saludo = horaActual < 12 ? 'Buenos días' : horaActual < 19 ? 'Buenas tardes' : 'Buenas noches';
  const fechaHoy = new Date().toLocaleDateString('es-PE', { weekday: 'long', day: 'numeric', month: 'long', year: 'numeric' });

  return (
    <Box sx={{ width: '100%', maxWidth: 1100, display: 'flex', flexDirection: 'column', alignItems: 'center', pt: { xs: 2, sm: 3 }, pb: 3 }}>
      {logoEmpresa && (
        <Avatar src={logoEmpresa} variant="rounded" sx={{ width: 64, height: 64, mb: 1.5, boxShadow: 2 }} />
      )}
      <Typography variant="h5" fontWeight={800} textAlign="center" sx={{ color: '#12324a' }}>
        {saludo}{nombreUsuario ? `, ${nombreUsuario}` : ''}
      </Typography>
      <Typography variant="body2" color="text.secondary" textAlign="center" sx={{ mb: 3, textTransform: 'capitalize' }}>
        {fechaHoy}
      </Typography>

      {secciones.length > 0 ? (
        <Box sx={{ width: '100%', display: 'flex', flexDirection: 'column', gap: 2 }}>
          {secciones.map((sec) => (
            <Paper key={sec.modulo} variant="outlined" sx={{ p: 2, borderRadius: 3, borderColor: '#e6e6e6' }}>
              <Box display="flex" alignItems="center" gap={1} mb={1.5}>
                {sec.icon}
                <Typography variant="subtitle1" fontWeight={700} sx={{ color: '#12324a' }}>{sec.label}</Typography>
              </Box>
              <Box display="flex" flexWrap="wrap" gap={1}>
                {sec.items.map((it) => (
                  <Button
                    key={it.page}
                    onClick={() => onNavigate(it.page)}
                    variant="outlined"
                    size="small"
                    startIcon={it.icon}
                    sx={{
                      borderRadius: 5, textTransform: 'none', fontWeight: 600,
                      borderColor: '#e0e0e0', color: '#333', backgroundColor: '#fff',
                      '&:hover': { backgroundColor: '#f2f7fd', borderColor: '#90caf9' },
                    }}
                  >
                    {it.label}
                  </Button>
                ))}
              </Box>
            </Paper>
          ))}
        </Box>
      ) : (
        <Typography variant="body2" color="text.secondary" textAlign="center">
          Usa el menú lateral para comenzar a trabajar.
        </Typography>
      )}
    </Box>
  );
}

const Dashboard = () => {
  const esAdmin = (() => {
    try { return JSON.parse(localStorage.getItem('usuario') || 'null')?.perfil_id === 1; }
    catch { return false; }
  })();
  const esSuperAdmin = (() => {
    try { return JSON.parse(localStorage.getItem('usuario') || 'null')?.es_superadmin === 1; }
    catch { return false; }
  })();

  const [activePage, setActivePage] = React.useState('');
  const [open, setOpen] = React.useState(false);
  // Estados para colapsar submenús
  const [openMantenimiento, setOpenMantenimiento] = React.useState(false);
  const [openComprasMenu, setOpenComprasMenu] = React.useState(false);
  const [openContabilidadMenu, setOpenContabilidadMenu] = React.useState(false);
  const { empresas: empresasContables, empresaActiva } = useEmpresaActiva();
  const [openRrhhMenu, setOpenRrhhMenu] = React.useState(false);
  const [openProduccionMenu, setOpenProduccionMenu] = React.useState(false);
  const [openFacturacion, setOpenFacturacion] = React.useState(false);
  const [modulosHabilitados, setModulosHabilitados] = React.useState(null); // null = cargando
  const [dashboardData, setDashboardData] = React.useState(DASHBOARD_DEFAULT);
  const [dashboardLoading, setDashboardLoading] = React.useState(true);
  const [dashboardError, setDashboardError] = React.useState('');
  const [activeInsight, setActiveInsight] = React.useState('ventasMes');
  const [activeRoadmap, setActiveRoadmap] = React.useState('compras');
  const [clienteDetalle, setClienteDetalle] = React.useState(CLIENTE_DETALLE_DEFAULT);
  const [clienteDetalleLoading, setClienteDetalleLoading] = React.useState(false);
  const [clienteDetalleError, setClienteDetalleError] = React.useState('');
  const [logoEmpresa, setLogoEmpresa] = React.useState(null);
  const [asientoAAbrir, setAsientoAAbrir] = React.useState(null);
  const explorationSectionRef = React.useRef(null);
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

  React.useEffect(() => {
    obtenerEmpresaConfig()
      .then((config) => {
        if (config?.logo_base64) {
          setLogoEmpresa(config.logo_base64);
          setFaviconFromLogo(config.logo_base64);
        }
      })
      .catch(() => {
        // Sin logo disponible: se queda el ícono genérico por defecto.
      });
  }, []);

  const handleDrawer = () => setOpen(!open);
  const setPage = (page) => { setActivePage(page); setOpen(false); };

  const tieneModulo = (codigo) => esAdmin || (modulosHabilitados !== null && modulosHabilitados.has(codigo));
  // null (cargando) se trata como "sí mostrar" para no parpadear el panel de KPIs en cada carga
  const mostrarPanelInicio = esAdmin || modulosHabilitados === null || modulosHabilitados.has('panel_inicio');
  const nombreUsuarioActual = (() => {
    try { return JSON.parse(localStorage.getItem('usuario') || 'null')?.username || ''; }
    catch { return ''; }
  })();
  const seccionesAccesoDirecto = SECCIONES_ACCESO_DIRECTO.filter((s) => tieneModulo(s.modulo));

  const handleLogout = () => {
    localStorage.removeItem('token');
    window.location.href = '/login';
  };

  // ── NOTIFICACIONES ─────────────────────────────────────────────────────────
  const [notif, setNotif] = React.useState(null);
  const [notifLoading, setNotifLoading] = React.useState(false);
  const [notifAnchor, setNotifAnchor] = React.useState(null);
  const [notifVisto, setNotifVisto] = React.useState(() => Number(localStorage.getItem('notif_visto') || 0));
  // Nivel 1 (grupos grandes) y nivel 2 (dentro de "Comprobantes", por tipo de
  // documento) -- colapsados por defecto para que el panel sea escaneable.
  const [notifOpenGrupo, setNotifOpenGrupo] = React.useState({});
  const [notifOpenTipo, setNotifOpenTipo] = React.useState({});
  // Detalle de un ítem puntual + resolución con comentario.
  const [notifDetalle, setNotifDetalle] = React.useState(null); // { categoria, item, titulo, lineas: [] }
  const [notifComentario, setNotifComentario] = React.useState('');
  const [notifResolviendo, setNotifResolviendo] = React.useState(false);
  // Historial de resueltos (quién, cuándo, por qué) + reabrir.
  const [notifHistorialOpen, setNotifHistorialOpen] = React.useState(false);
  const [notifHistorial, setNotifHistorial] = React.useState([]);
  const [notifHistorialLoading, setNotifHistorialLoading] = React.useState(false);
  // Vista rápida del documento real detrás de una alerta (botón "Ver documento").
  const [notifDocPreview, setNotifDocPreview] = React.useState(null); // { loading, error, data }

  const cargarNotificaciones = React.useCallback(async () => {
    setNotifLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('/api/notificaciones', { headers: { Authorization: `Bearer ${token}` } });
      setNotif(res.data);
    } catch { setNotif({}); }
    setNotifLoading(false);
  }, []);

  React.useEffect(() => {
    cargarNotificaciones();
    const interval = setInterval(cargarNotificaciones, 10 * 60 * 1000);
    return () => clearInterval(interval);
  }, [cargarNotificaciones]);

  const notifTotal = notif ? (
    (notif.stock_agotado?.length || 0) +
    (notif.stock_bajo?.length || 0) +
    (notif.cpe_error?.length || 0) +
    (notif.cpe_pendiente?.length || 0) +
    (notif.cobros_vencidos?.length || 0) +
    (notif.pagos_vencidos?.length || 0) +
    (notif.cobros_proximos?.length || 0) +
    (notif.pagos_proximos?.length || 0) +
    (notif.cotizaciones_antiguas?.length || 0) +
    (notif.kardex_errores?.length || 0) +
    (notif.anulacion_error?.length || 0) +
    (notif.guia_error?.length || 0)
  ) : 0;

  const notifBadge = notifTotal > 0 && Date.now() - notifVisto > 4 * 60 * 60 * 1000 ? notifTotal : 0;

  const marcarVisto = () => {
    const ts = Date.now();
    localStorage.setItem('notif_visto', ts);
    setNotifVisto(ts);
  };

  const fmtCur = v => 'S/ ' + Number(v || 0).toLocaleString('es-PE', { minimumFractionDigits: 2, maximumFractionDigits: 2 });

  // Comprobantes con error/pendiente, agrupados por tipo de documento (Factura/
  // Boleta/NC/ND) en vez de la lista mezclada que había antes.
  const comprobantesPorTipo = React.useMemo(() => {
    if (!notif) return {};
    const todos = [
      ...(notif.cpe_error || []).map(c => ({ ...c, _categoria: 'cpe_error', _estado: 'Error/Rechazado' })),
      ...(notif.cpe_pendiente || []).map(c => ({ ...c, _categoria: 'cpe_pendiente', _estado: 'Pendiente de envío' })),
      ...(notif.anulacion_error || []).map(c => ({ ...c, _categoria: 'anulacion_error', _estado: `Error de anulación (${c.estado === 'ERROR_DEFINITIVO' ? 'definitivo' : 'reintentando'})` })),
      ...(notif.guia_error || []).map(c => ({ ...c, _categoria: 'guia_error', tipo_label: 'Guía de Remisión', _estado: c.estado === 'RECHAZADO' ? 'Rechazada' : 'Error de envío' })),
    ];
    const porTipo = {};
    for (const c of todos) {
      const key = c.tipo_label || 'Otros';
      if (!porTipo[key]) porTipo[key] = [];
      porTipo[key].push(c);
    }
    return porTipo;
  }, [notif]);
  const comprobantesTotal = Object.values(comprobantesPorTipo).reduce((a, arr) => a + arr.length, 0);

  const toggleGrupo = (key) => setNotifOpenGrupo(prev => ({ ...prev, [key]: !prev[key] }));
  const toggleTipo = (key) => setNotifOpenTipo(prev => ({ ...prev, [key]: !prev[key] }));

  const abrirDetalleNotif = (categoria, item, texto) => {
    setNotifComentario('');
    setNotifDetalle({ categoria, item, titulo: texto });
  };

  const TIPO_DOC_LABEL = { comprobante: 'Comprobante', guia: 'Guía de Remisión', compra: 'Compra', cotizacion: 'Cotización', nota_venta: 'Nota de Venta' };

  const verDocumentoNotif = async (docRef) => {
    if (!docRef || !docRef.tipo || !docRef.id) return;
    setNotifDocPreview({ loading: true, error: null, data: null });
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get(`/api/notificaciones/documento/${docRef.tipo}/${docRef.id}`, { headers: { Authorization: `Bearer ${token}` } });
      setNotifDocPreview({ loading: false, error: null, data: res.data });
    } catch (err) {
      setNotifDocPreview({ loading: false, error: err.response?.data?.error || 'No se pudo cargar el documento', data: null });
    }
  };

  const resolverNotificacion = async () => {
    if (!notifDetalle) return;
    setNotifResolviendo(true);
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/notificaciones/resolver', {
        categoria: notifDetalle.categoria,
        item_key: notifDetalle.item.item_key,
        item_descripcion: notifDetalle.titulo,
        comentario: notifComentario,
        usuario: nombreUsuarioActual,
      }, { headers: { Authorization: `Bearer ${token}` } });
      setNotifDetalle(null);
      setNotifComentario('');
      cargarNotificaciones();
    } catch (e) {
      alert('No se pudo marcar como resuelto: ' + (e.response?.data?.error || e.message));
    }
    setNotifResolviendo(false);
  };

  const cargarHistorialNotif = React.useCallback(async () => {
    setNotifHistorialLoading(true);
    try {
      const token = localStorage.getItem('token');
      const res = await axios.get('/api/notificaciones/historial', { headers: { Authorization: `Bearer ${token}` } });
      setNotifHistorial(res.data || []);
    } catch { setNotifHistorial([]); }
    setNotifHistorialLoading(false);
  }, []);

  const reabrirNotificacion = async (id) => {
    try {
      const token = localStorage.getItem('token');
      await axios.post('/api/notificaciones/reabrir', { id }, { headers: { Authorization: `Bearer ${token}` } });
      cargarHistorialNotif();
      cargarNotificaciones();
    } catch (e) {
      alert('No se pudo reabrir: ' + (e.response?.data?.error || e.message));
    }
  };

  // Fila clickeable de un ítem individual -- abre el diálogo de detalle/resolver.
  const NotifItemRow = ({ categoria, item, texto, onAbrir }) => (
    <Box
      onClick={() => onAbrir(categoria, item, texto)}
      sx={{
        px: 2, py: 0.6, cursor: 'pointer', display: 'flex', alignItems: 'center', gap: 0.5,
        borderBottom: '1px solid', borderColor: 'divider',
        '&:hover': { bgcolor: 'action.hover' },
      }}
    >
      <Typography variant="caption" sx={{ color: 'text.secondary', flex: 1 }}>{texto}</Typography>
      <ChevronRightIcon sx={{ fontSize: 14, color: 'text.disabled' }} />
    </Box>
  );

  // Grupo nivel 1: ícono + título + contador + flecha, colapsable.
  const NotifGrupo = ({ grupoKey, color, icon, title, count, children }) => count === 0 ? null : (
    <Box>
      <Box
        onClick={() => toggleGrupo(grupoKey)}
        sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 1, bgcolor: color + '.50', borderLeft: '3px solid', borderColor: color + '.main', cursor: 'pointer' }}
      >
        {icon}
        <Typography variant="body2" fontWeight={700} color={color + '.dark'} sx={{ flex: 1 }}>{title}</Typography>
        <Chip label={count} size="small" color={color} sx={{ height: 20, fontSize: '0.7rem' }} />
        {notifOpenGrupo[grupoKey] ? <ExpandLess sx={{ fontSize: 20 }} /> : <ExpandMore sx={{ fontSize: 20 }} />}
      </Box>
      <Collapse in={!!notifOpenGrupo[grupoKey]} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Box>
  );

  // Subgrupo nivel 2 (solo dentro de "Comprobantes Electrónicos"): por tipo de documento.
  const NotifSubgrupo = ({ tipoKey, title, count, children }) => count === 0 ? null : (
    <Box sx={{ pl: 1 }}>
      <Box
        onClick={() => toggleTipo(tipoKey)}
        sx={{ display: 'flex', alignItems: 'center', gap: 1, px: 2, py: 0.7, cursor: 'pointer', '&:hover': { bgcolor: 'action.hover' } }}
      >
        <Typography variant="caption" fontWeight={700} sx={{ flex: 1 }}>{title}</Typography>
        <Chip label={count} size="small" variant="outlined" sx={{ height: 18, fontSize: '0.65rem' }} />
        {notifOpenTipo[tipoKey] ? <ExpandLess sx={{ fontSize: 16 }} /> : <ExpandMore sx={{ fontSize: 16 }} />}
      </Box>
      <Collapse in={!!notifOpenTipo[tipoKey]} timeout="auto" unmountOnExit>
        {children}
      </Collapse>
    </Box>
  );

  const cargarDashboard = React.useCallback(async () => {
    try {
      setDashboardLoading(true);
      setDashboardError('');
      const response = await axios.get('/api/comprobante/dashboard/ventas');
      setDashboardData(response.data || DASHBOARD_DEFAULT);
    } catch (error) {
      console.error('Error cargando dashboard de ventas:', error);
      setDashboardError(error.response?.data?.error || 'No se pudo cargar el dashboard de ventas.');
      setDashboardData(DASHBOARD_DEFAULT);
    } finally {
      setDashboardLoading(false);
    }
  }, []);

  React.useEffect(() => {
    cargarDashboard();
  }, [cargarDashboard]);

  React.useEffect(() => {
    axios.get('/api/usuario-modulo/mis-modulos')
      .then(res => setModulosHabilitados(new Set(res.data)))
      .catch(() => setModulosHabilitados(new Set()));
  }, []);

  const cargarDetalleCliente = React.useCallback(async (clienteId) => {
    if (!clienteId) return;
    try {
      setClienteDetalleLoading(true);
      setClienteDetalleError('');
      const response = await axios.get(`/api/comprobante/dashboard/ventas/cliente/${clienteId}`);
      setClienteDetalle(response.data || CLIENTE_DETALLE_DEFAULT);
    } catch (error) {
      console.error('Error cargando detalle del cliente:', error);
      setClienteDetalle(CLIENTE_DETALLE_DEFAULT);
      setClienteDetalleError(error.response?.data?.error || 'No se pudo cargar el detalle del cliente.');
    } finally {
      setClienteDetalleLoading(false);
    }
  }, []);

  const dashboardCards = [
    {
      key: 'ventasMes',
      label: 'Ventas Netas del Mes',
      value: formatCurrency(dashboardData.resumen.ventasMesActual),
      helper: `${dashboardData.resumen.variacionMensual >= 0 ? '+' : ''}${Number(dashboardData.resumen.variacionMensual || 0).toFixed(1)}% vs mes anterior`,
      color: 'linear-gradient(135deg, #0d47a1 0%, #1976d2 100%)',
    },
    {
      key: 'ticket',
      label: 'Ticket Promedio',
      value: formatCurrency(dashboardData.resumen.ticketPromedioMesActual),
      helper: `${formatNumber(dashboardData.resumen.comprobantesMesActual)} comprobantes emitidos`,
      color: 'linear-gradient(135deg, #00695c 0%, #00897b 100%)',
    },
    {
      key: 'clientes',
      label: 'Clientes Activos',
      value: formatNumber(dashboardData.resumen.clientesActivosMesActual),
      helper: 'Clientes con ventas este mes',
      color: 'linear-gradient(135deg, #6a1b9a 0%, #8e24aa 100%)',
    },
    {
      key: 'embudo',
      label: 'Guías Emitidas',
      value: formatNumber(dashboardData.resumen.guiasMesActual),
      helper: `${formatNumber(dashboardData.resumen.guiasRemitenteMesActual)} remitente / ${formatNumber(dashboardData.resumen.guiasTransportistaMesActual)} transportista`,
      color: 'linear-gradient(135deg, #ef6c00 0%, #fb8c00 100%)',
    },
    {
      key: 'sunat',
      label: 'Pendientes SUNAT',
      value: formatNumber(dashboardData.resumen.pendientesSunat),
      helper: 'Ventas aún no cerradas en flujo CPE',
      color: 'linear-gradient(135deg, #37474f 0%, #546e7a 100%)',
    },
    {
      key: 'roadmap',
      label: 'Compras',
      value: 'Próximamente',
      helper: 'La tarjeta ya está reservada para la siguiente fase',
      color: 'linear-gradient(135deg, #455a64 0%, #607d8b 100%)',
    },
  ];

  const ventasDiarias = (dashboardData.exploracion?.ventasDiarias || []).map((item) => ({
    ...item,
    fechaCorta: formatDateShort(item.fecha),
  }));

  const topProductos = dashboardData.exploracion?.topProductos || [];
  const clientesExploracion = dashboardData.exploracion?.clientes || [];
  const vendedoresExploracion = dashboardData.exploracion?.vendedores || [];
  const embudoExploracion = dashboardData.exploracion?.embudo || DASHBOARD_DEFAULT.exploracion.embudo;
  const roadmapModules = dashboardData.meta?.modulosFuturos || DASHBOARD_DEFAULT.meta.modulosFuturos;

  const ventasMensuales = dashboardData.series.ventasMensuales.map((item) => ({
    ...item,
    periodo: formatMonthLabel(item),
  }));

  const documentosPorTipo = dashboardData.series.documentosPorTipo.map((item) => ({
    ...item,
    tipo: TIPO_COMPROBANTE_LABELS[item.tipoComprobante] || item.tipoComprobante,
  }));

  const topClientes = dashboardData.series.topClientes.map((item) => ({
    ...item,
    clienteCorto: item.cliente?.length > 18 ? `${item.cliente.slice(0, 18)}...` : item.cliente,
  }));

  const estadosSunat = dashboardData.series.estadosSunat.map((item) => ({
    ...item,
    fill: ESTADO_COLOR[item.estado] || '#5c6bc0',
  }));

  const handleCardClick = (key) => {
    const targetInsight = key === 'roadmap' ? 'roadmap' : key;
    setActiveInsight(targetInsight);
    if (targetInsight === 'roadmap') {
      setActiveRoadmap('compras');
    }

    requestAnimationFrame(() => {
      explorationSectionRef.current?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  };

  return (
    <Box sx={{ display: 'flex', minHeight: '100vh', bgcolor: '#f5f5f5', justifyContent: { xs: 'flex-start', sm: 'center' } }}>
      <AppBar position="fixed">
        <Toolbar sx={{ px: { xs: 1, sm: 2 } }}>
          <IconButton color="inherit" edge="start" size={isMobile ? 'small' : 'medium'} onClick={handleDrawer} sx={{ mr: { xs: 1, sm: 2 } }}>
            <MenuIcon />
          </IconButton>
          <Typography variant="h6" sx={{ flexGrow: 1, fontSize: { xs: '1.05rem', sm: '1.25rem' } }}>
            {isMobile ? 'InsightSoft' : 'ERP InsightSoft'}
          </Typography>
          {(() => {
            try {
              const u = JSON.parse(localStorage.getItem('usuario') || 'null');
              return u && u.username === 'admin' && process.env.REACT_APP_ENABLE_ADMIN === 'true';
            } catch { return false; }
          })() && (
            <IconButton color="inherit" title="Panel Admin" size={isMobile ? 'small' : 'medium'} onClick={() => window.location.href = '/admin'} sx={{ mr: { xs: 0.5, sm: 1 } }}>
              {isMobile ? <AdminPanelSettingsIcon fontSize="small" /> : <span style={{ fontSize: 13, fontWeight: 700 }}>ADMIN</span>}
            </IconButton>
          )}
          {empresasContables.length > 0 && (
            <Chip
              icon={<BusinessIcon fontSize="small" />}
              label={isMobile ? 'Empresa' : (empresaActiva ? empresaActiva.razon_social : 'Elegir empresa')}
              color="secondary" variant="outlined" size="small"
              onClick={() => setPage('cont_seleccionar_empresa')}
              sx={{ color: 'white', borderColor: 'rgba(255,255,255,0.5)', mr: { xs: 0.5, sm: 1.5 }, maxWidth: { xs: 90, sm: 220 }, '& .MuiChip-label': { overflow: 'hidden', textOverflow: 'ellipsis' }, '& .MuiChip-icon': { color: 'white' } }}
            />
          )}
          <IconButton color="inherit" size={isMobile ? 'small' : 'medium'} onClick={e => setNotifAnchor(e.currentTarget)} title="Notificaciones">
            <Badge badgeContent={notifBadge} color="error" max={99}>
              {notifBadge > 0 ? <NotificationsIcon fontSize={isMobile ? 'small' : 'medium'} /> : <NotificationsNoneIcon fontSize={isMobile ? 'small' : 'medium'} />}
            </Badge>
          </IconButton>
          <IconButton color="inherit" size={isMobile ? 'small' : 'medium'} onClick={handleLogout}>
            <LogoutIcon fontSize={isMobile ? 'small' : 'medium'} />
          </IconButton>
        </Toolbar>
      </AppBar>

      {/* ── PANEL NOTIFICACIONES ─────────────────────────────────────────────── */}
      <Popover
        open={Boolean(notifAnchor)}
        anchorEl={notifAnchor}
        onClose={() => setNotifAnchor(null)}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
        transformOrigin={{ vertical: 'top', horizontal: 'right' }}
        PaperProps={{ sx: { width: 400, maxHeight: 560, overflow: 'auto', boxShadow: 6 } }}
      >
        {/* Header */}
        <Box sx={{ px: 2, py: 1.2, borderBottom: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', gap: 1, position: 'sticky', top: 0, bgcolor: 'background.paper', zIndex: 1 }}>
          <NotificationsIcon color="primary" fontSize="small" />
          <Typography variant="subtitle2" fontWeight={700} sx={{ flex: 1 }}>Notificaciones</Typography>
          <IconButton size="small" onClick={cargarNotificaciones} title="Actualizar" disabled={notifLoading}>
            {notifLoading ? <CircularProgress size={14} /> : <span style={{ fontSize: 14 }}>↻</span>}
          </IconButton>
          <Button size="small" sx={{ fontSize: '0.7rem', minWidth: 0, px: 1 }} onClick={marcarVisto}>✓ Visto</Button>
        </Box>

        {notifLoading ? (
          <Box sx={{ textAlign: 'center', py: 4 }}>
            <CircularProgress size={24} />
          </Box>
        ) : notifTotal === 0 ? (
          <Box sx={{ px: 2, py: 3, textAlign: 'center' }}>
            <Typography variant="body2" color="text.secondary">Sin alertas activas 🎉</Typography>
          </Box>
        ) : (
          <Box>
            <NotifGrupo grupoKey="stock" color="warning" icon={<Inventory2Icon color="warning" sx={{ fontSize: 18 }} />} title="Stock"
              count={(notif.stock_agotado?.length || 0) + (notif.stock_bajo?.length || 0)}>
              {(notif.stock_agotado || []).map((p, i) => (
                <NotifItemRow key={'sa' + i} categoria="stock_agotado" item={p}
                  texto={`🔴 Agotado: ${p.codigo ? p.codigo + ' — ' : ''}${p.nombre}`} onAbrir={abrirDetalleNotif} />
              ))}
              {(notif.stock_bajo || []).map((p, i) => (
                <NotifItemRow key={'sb' + i} categoria="stock_bajo" item={p}
                  texto={`🟠 Bajo mínimo: ${p.codigo ? p.codigo + ' — ' : ''}${p.nombre} (${p.stock}/${p.minimo})`} onAbrir={abrirDetalleNotif} />
              ))}
            </NotifGrupo>

            <NotifGrupo grupoKey="comprobantes" color="error" icon={<ReceiptIcon color="error" sx={{ fontSize: 18 }} />} title="Comprobantes Electrónicos"
              count={comprobantesTotal}>
              {Object.entries(comprobantesPorTipo).map(([tipo, items]) => (
                <NotifSubgrupo key={tipo} tipoKey={tipo} title={tipo} count={items.length}>
                  {items.map((c, i) => (
                    <NotifItemRow key={tipo + i} categoria={c._categoria} item={c}
                      texto={`${c._categoria === 'cpe_error' ? '⚡' : c._categoria === 'anulacion_error' ? '🚫' : c._categoria === 'guia_error' ? '🚚' : '⏳'} ${c.doc} — ${c._estado} (${fmtFechaISO(c.fecha)})`}
                      onAbrir={abrirDetalleNotif} />
                  ))}
                </NotifSubgrupo>
              ))}
            </NotifGrupo>

            <NotifGrupo grupoKey="tesoreria" color="info" icon={<PaymentIcon color="info" sx={{ fontSize: 18 }} />} title="Tesorería"
              count={(notif.cobros_vencidos?.length || 0) + (notif.pagos_vencidos?.length || 0) + (notif.cobros_proximos?.length || 0) + (notif.pagos_proximos?.length || 0)}>
              {(notif.cobros_vencidos || []).map((m, i) => (
                <NotifItemRow key={'cv' + i} categoria="cobros_vencidos" item={m}
                  texto={`🔴 Cobro vencido: ${m.doc} — ${m.cliente || '—'} — ${fmtCur(m.pendiente)} (venció ${fmtFechaISO(m.vence)})`} onAbrir={abrirDetalleNotif} />
              ))}
              {(notif.pagos_vencidos || []).map((m, i) => (
                <NotifItemRow key={'pv' + i} categoria="pagos_vencidos" item={m}
                  texto={`🔴 Pago vencido: ${m.doc} — ${m.proveedor || '—'} — ${fmtCur(m.pendiente)} (venció ${fmtFechaISO(m.vence)})`} onAbrir={abrirDetalleNotif} />
              ))}
              {(notif.cobros_proximos || []).map((m, i) => (
                <NotifItemRow key={'cp' + i} categoria="cobros_proximos" item={m}
                  texto={`🔵 Cobro próximo: ${m.doc} — ${m.cliente || '—'} — ${fmtCur(m.pendiente)} vence ${fmtFechaISO(m.vence)}`} onAbrir={abrirDetalleNotif} />
              ))}
              {(notif.pagos_proximos || []).map((m, i) => (
                <NotifItemRow key={'pp' + i} categoria="pagos_proximos" item={m}
                  texto={`🔵 Pago próximo: ${m.doc} — ${m.proveedor || '—'} — ${fmtCur(m.pendiente)} vence ${fmtFechaISO(m.vence)}`} onAbrir={abrirDetalleNotif} />
              ))}
            </NotifGrupo>

            <NotifGrupo grupoKey="cotizaciones" color="warning" icon={<ListAltIcon color="warning" sx={{ fontSize: 18 }} />} title="Cotizaciones sin convertir"
              count={notif.cotizaciones_antiguas?.length || 0}>
              {(notif.cotizaciones_antiguas || []).map((c, i) => (
                <NotifItemRow key={'ca' + i} categoria="cotizaciones_antiguas" item={c}
                  texto={`📋 ${c.doc} — ${c.cliente || '—'} (${fmtFechaISO(c.fecha)})`} onAbrir={abrirDetalleNotif} />
              ))}
            </NotifGrupo>

            <NotifGrupo grupoKey="kardex" color="error" icon={<WarningAmberIcon color="error" sx={{ fontSize: 18 }} />} title="Kardex sin registrar"
              count={notif.kardex_errores?.length || 0}>
              {(notif.kardex_errores || []).map((e, i) => (
                <NotifItemRow key={'ke' + i} categoria="kardex_errores" item={e}
                  texto={`📦 ${e.tipo_documento} #${e.documento_id} — ${e.producto || 'producto'} (${fmtFechaISO(e.fecha)})`} onAbrir={abrirDetalleNotif} />
              ))}
            </NotifGrupo>
          </Box>
        )}

        <Box sx={{ px: 2, py: 1, borderTop: 1, borderColor: 'divider', display: 'flex', alignItems: 'center', justifyContent: 'space-between' }}>
          <Typography variant="caption" color="text.secondary">
            {notifTotal} alerta{notifTotal !== 1 ? 's' : ''} activa{notifTotal !== 1 ? 's' : ''}
          </Typography>
          <Button
            size="small" startIcon={<HistoryIcon sx={{ fontSize: 16 }} />}
            sx={{ fontSize: '0.7rem' }}
            onClick={() => { setNotifHistorialOpen(true); cargarHistorialNotif(); }}
          >
            Historial
          </Button>
        </Box>
      </Popover>

      {/* ── DETALLE DE UNA ALERTA + RESOLVER ─────────────────────────────────── */}
      <Dialog open={!!notifDetalle} onClose={() => { setNotifDetalle(null); setNotifComentario(''); }} maxWidth="xs" fullWidth>
        {notifDetalle && (<>
          <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: 18 }}>
            Detalle de la alerta
          </DialogTitle>
          <DialogContent sx={{ pt: 2 }}>
            <Typography variant="body2" sx={{ mb: 2 }}>{notifDetalle.titulo}</Typography>
            <Box sx={{ mb: 2, p: 1.5, bgcolor: '#f5f5f5', borderRadius: 1 }}>
              {Object.entries(notifDetalle.item)
                .filter(([k]) => !['item_key', 'tipo_comprobante', 'tipo_label', '_categoria', '_estado', '_docRef'].includes(k))
                .map(([k, v]) => (
                  <Typography key={k} variant="caption" display="block" color="text.secondary">
                    <b>{NOTIF_FIELD_LABEL[k] || k}:</b> {(k === 'fecha' || k === 'vence') ? fmtFechaISO(v) : String(v ?? '')}
                  </Typography>
                ))}
            </Box>
            {notifDetalle.item._docRef && (
              <Button
                size="small" variant="outlined" startIcon={<VisibilityIcon sx={{ fontSize: 16 }} />}
                sx={{ mb: 2 }}
                onClick={() => verDocumentoNotif(notifDetalle.item._docRef)}
              >
                Ver {TIPO_DOC_LABEL[notifDetalle.item._docRef.tipo] || 'documento'}
              </Button>
            )}
            <TextField
              label="Comentario (opcional)"
              placeholder="Ej: ya se corrigió manualmente, cliente avisado, etc."
              value={notifComentario}
              onChange={e => setNotifComentario(e.target.value)}
              multiline minRows={2} fullWidth size="small"
            />
          </DialogContent>
          <DialogActions>
            <Button onClick={() => { setNotifDetalle(null); setNotifComentario(''); }} color="inherit">Cerrar</Button>
            <Button
              onClick={resolverNotificacion}
              variant="contained" color="success" startIcon={<TaskAltIcon />}
              disabled={notifResolviendo}
            >
              {notifResolviendo ? 'Guardando...' : 'Marcar como resuelto'}
            </Button>
          </DialogActions>
        </>)}
      </Dialog>

      {/* ── VISTA RÁPIDA DEL DOCUMENTO DETRÁS DE LA ALERTA ───────────────────── */}
      <Dialog open={!!notifDocPreview} onClose={() => setNotifDocPreview(null)} maxWidth="sm" fullWidth>
        <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: 18, display: 'flex', alignItems: 'center', gap: 1 }}>
          <VisibilityIcon /> {notifDocPreview?.data ? `${TIPO_DOC_LABEL[notifDocPreview.data.tipo] || 'Documento'} ${notifDocPreview.data.titulo}` : 'Documento'}
        </DialogTitle>
        <DialogContent sx={{ pt: 2 }}>
          {notifDocPreview?.loading ? (
            <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress size={24} /></Box>
          ) : notifDocPreview?.error ? (
            <Alert severity="error">{notifDocPreview.error}</Alert>
          ) : notifDocPreview?.data ? (
            <>
              <Box sx={{ mb: 2, p: 1.5, bgcolor: '#f5f5f5', borderRadius: 1 }}>
                {notifDocPreview.data.subtitulo && (
                  <Typography variant="body2"><b>{notifDocPreview.data.tipo === 'compra' ? 'Proveedor' : 'Cliente'}:</b> {notifDocPreview.data.subtitulo}</Typography>
                )}
                <Typography variant="body2"><b>Fecha:</b> {fmtFechaISO(notifDocPreview.data.fecha)}</Typography>
                {notifDocPreview.data.estado && <Typography variant="body2"><b>Estado:</b> {notifDocPreview.data.estado}</Typography>}
                {notifDocPreview.data.total != null && <Typography variant="body2"><b>Total:</b> {fmtCur(notifDocPreview.data.total)}</Typography>}
              </Box>
              {Array.isArray(notifDocPreview.data.detalles) && notifDocPreview.data.detalles.length > 0 && (
                <TableContainer>
                  <Table size="small">
                    <TableHead>
                      <TableRow>
                        <TableCell>Código</TableCell>
                        <TableCell>Producto</TableCell>
                        <TableCell align="right">Cant.</TableCell>
                        <TableCell>Almacén</TableCell>
                        {notifDocPreview.data.detalles[0].precio != null && <TableCell align="right">Precio</TableCell>}
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {notifDocPreview.data.detalles.map((d, i) => (
                        <TableRow key={i}>
                          <TableCell>{d.codigo_producto || '—'}</TableCell>
                          <TableCell>{d.descripcion || '—'}</TableCell>
                          <TableCell align="right">{d.cantidad}</TableCell>
                          <TableCell>{d.almacen || '—'}</TableCell>
                          {d.precio != null && <TableCell align="right">{fmtCur(d.precio)}</TableCell>}
                        </TableRow>
                      ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              )}
            </>
          ) : null}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNotifDocPreview(null)} color="inherit">Cerrar</Button>
        </DialogActions>
      </Dialog>

      {/* ── HISTORIAL DE RESUELTOS ───────────────────────────────────────────── */}
      <Dialog open={notifHistorialOpen} onClose={() => setNotifHistorialOpen(false)} maxWidth="md" fullWidth>
        <DialogTitle sx={{ bgcolor: '#1976d2', color: '#fff', fontWeight: 'bold', fontSize: 18, display: 'flex', alignItems: 'center', gap: 1 }}>
          <HistoryIcon /> Historial de alertas resueltas
        </DialogTitle>
        <DialogContent>
          {notifHistorialLoading ? (
            <Box sx={{ textAlign: 'center', py: 4 }}><CircularProgress size={24} /></Box>
          ) : notifHistorial.length === 0 ? (
            <Box sx={{ py: 3, textAlign: 'center' }}><Typography variant="body2" color="text.secondary">Todavía no se ha resuelto ninguna alerta.</Typography></Box>
          ) : (
            <TableContainer sx={{ mt: 1 }}>
              <Table size="small">
                <TableHead>
                  <TableRow>
                    <TableCell>Categoría</TableCell>
                    <TableCell>Descripción</TableCell>
                    <TableCell>Comentario</TableCell>
                    <TableCell>Usuario</TableCell>
                    <TableCell>Fecha</TableCell>
                    <TableCell></TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {notifHistorial.map(h => (
                    <TableRow key={h.id}>
                      <TableCell><Chip label={NOTIF_CATEGORIA_LABEL[h.categoria] || h.categoria} size="small" /></TableCell>
                      <TableCell sx={{ maxWidth: 220 }}>{h.item_descripcion || '—'}</TableCell>
                      <TableCell sx={{ maxWidth: 200, color: 'text.secondary' }}>{h.comentario || '—'}</TableCell>
                      <TableCell>{h.usuario || '—'}</TableCell>
                      <TableCell>{fmtFechaISO(h.fecha_resuelto)}</TableCell>
                      <TableCell>
                        <Button size="small" startIcon={<UndoIcon sx={{ fontSize: 14 }} />} onClick={() => reabrirNotificacion(h.id)}>
                          Reabrir
                        </Button>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={() => setNotifHistorialOpen(false)} color="error" variant="contained">Cerrar</Button>
        </DialogActions>
      </Dialog>
      {(() => { const listContent = (
        <List sx={{ width: { xs: 280, sm: 270 } }}>
          {logoEmpresa && (
            <Box sx={{ display: 'flex', justifyContent: 'center', py: 2 }}>
              <Avatar
                src={`data:image/png;base64,${logoEmpresa}`}
                sx={{ width: 64, height: 64, '& .MuiAvatar-img': { objectFit: 'contain' } }}
              />
            </Box>
          )}
          {/* INICIO */}
          <ListItem button onClick={() => { setActivePage(''); setOpen(false); }}>
            <ListItemIcon><HomeIcon color="primary" /></ListItemIcon>
            <ListItemText primary="Inicio"  primaryTypographyProps={{ fontWeight: 'bold' }} />
          </ListItem>
          {/* MANTENIMIENTO */}
          {tieneModulo('mantenimiento') && (<>
          <ListItem button onClick={() => setOpenMantenimiento(!openMantenimiento)}>
            <ListItemIcon><SettingsIcon color="secondary" /></ListItemIcon>
            <ListItemText primary="Mantenimiento" primaryTypographyProps={{ fontWeight: 'bold' }} />
            {openMantenimiento ? <ExpandLess /> : <ExpandMore />}
          </ListItem>
          <Collapse in={openMantenimiento} timeout="auto" unmountOnExit>
            <List component="div" disablePadding>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('almacenes')}>
                <ListItemIcon><StoreIcon color="info" /></ListItemIcon>
                <ListItemText primary="Almacenes" />
              </ListItem>
              {esSuperAdmin && (
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('configEmpresa')}>
                <ListItemIcon><BusinessIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Configuración Empresa" />
              </ListItem>
              )}
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('configWhatsApp')}>
                <ListItemIcon><WhatsAppIcon sx={{ color: '#25d366' }} /></ListItemIcon>
                <ListItemText primary="Plantillas WhatsApp" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('configEmail')}>
                <ListItemIcon><EmailIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Configuración Email" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('sucursales')}>
                <ListItemIcon><StoreIcon color="secondary" /></ListItemIcon>
                <ListItemText primary="Sucursales" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('series')}>
                <ListItemIcon><NumbersIcon color="warning" /></ListItemIcon>
                <ListItemText primary="Series" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('seriesSucursal')}>
                <ListItemIcon><LayersIcon color="info" /></ListItemIcon>
                <ListItemText primary="Series por Sucursal" />
              </ListItem>
              {esSuperAdmin && (
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('usuarios')}>
                  <ListItemIcon><PeopleIcon color="success" /></ListItemIcon>
                  <ListItemText primary="Gestión de Usuarios" />
                </ListItem>
              )}
              {esSuperAdmin && (
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('permisosUsuario')}>
                  <ListItemIcon><LockPersonIcon color="error" /></ListItemIcon>
                  <ListItemText primary="Permisos de Usuario" />
                </ListItem>
              )}
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('tipoDocumento')}>
                <ListItemIcon><DocumentScannerIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Tipo de Documento" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('tipoDocIdentidad')}>
                <ListItemIcon><AssignmentIndIcon color="secondary" /></ListItemIcon>
                <ListItemText primary="Tipo de Doc. Identidad" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('auxiliares')}>
                <ListItemIcon><ListAltIcon color="info" /></ListItemIcon>
                <ListItemText primary="Auxiliares" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('condicionPago')}>
                <ListItemIcon><PaymentIcon color="success" /></ListItemIcon>
                <ListItemText primary="Condición de Pago" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('tipoCambio')}>
                <ListItemIcon><CompareArrowsIcon color="warning" /></ListItemIcon>
                <ListItemText primary="Tipo de Cambio" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('categorias')}>
                <ListItemIcon><CategoryIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Categorías" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('subcategorias')}>
                <ListItemIcon><LayersIcon color="secondary" /></ListItemIcon>
                <ListItemText primary="Subcategorías" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('marcas')}>
                <ListItemIcon><LocalOfferIcon color="info" /></ListItemIcon>
                <ListItemText primary="Marcas" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('modelos')}>
                <ListItemIcon><StoreIcon color="warning" /></ListItemIcon>
                <ListItemText primary="Modelos" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('tallas')}>
                <ListItemIcon><StraightenIcon color="success" /></ListItemIcon>
                <ListItemText primary="Tallas" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('colores')}>
                <ListItemIcon><ColorLensIcon color="secondary" /></ListItemIcon>
                <ListItemText primary="Colores" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('unidades')}>
                <ListItemIcon><StraightenIcon color="info" /></ListItemIcon>
                <ListItemText primary="Unidad de Medida" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('conversiones')}>
                <ListItemIcon><CompareArrowsIcon color="secondary" /></ListItemIcon>
                <ListItemText primary="Conversiones" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('productos')}>
                <ListItemIcon><StoreIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Productos" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('ubigeoManager')}>
                <ListItemIcon><MapIcon color="warning" /></ListItemIcon>
                <ListItemText primary="Gestión de Ubigeo" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('choferes')}>
                <ListItemIcon><BadgeIcon color="primary" /></ListItemIcon>
                <ListItemText primary="Choferes" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('vehiculos')}>
                <ListItemIcon><StoreIcon color="secondary" /></ListItemIcon>
                <ListItemText primary="Vehículos" />
              </ListItem>
              <ListItem button sx={{ pl: 4 }} onClick={() => setPage('transportistas')}>
                <ListItemIcon><StoreIcon color="warning" /></ListItemIcon>
                <ListItemText primary="Transportistas" />
              </ListItem>
            </List>
          </Collapse>
          </>)}
          {/* FACTURACIÓN */}
          {tieneModulo('facturacion') && (<>
            <ListItem button onClick={() => setOpenFacturacion(!openFacturacion)}>
              <ListItemIcon><ReceiptIcon color="success" /></ListItemIcon>
              <ListItemText primary="Facturación" primaryTypographyProps={{ fontWeight: 'bold' }} />
              {openFacturacion ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openFacturacion} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cotizaciones')}>
                  <ListItemIcon><ListAltIcon color="primary" /></ListItemIcon>
                  <ListItemText primary="Cotizaciones" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('notaVenta')}>
                  <ListItemIcon><DraftsIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Nota de Venta" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('boleta')}>
                  <ListItemIcon><PointOfSaleIcon color="success" /></ListItemIcon>
                  <ListItemText primary="Boleta" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('factura')}>
                  <ListItemIcon><ReceiptIcon color="info" /></ListItemIcon>
                  <ListItemText primary="Factura" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('notaCredito')}>
                  <ListItemIcon><CreditCardIcon color="warning" /></ListItemIcon>
                  <ListItemText primary="Nota de Crédito" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('notaDebito')}>
                  <ListItemIcon><CallMadeIcon color="error" /></ListItemIcon>
                  <ListItemText primary="Nota de Débito" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('guiaRemision')}>
                  <ListItemIcon><LocalShippingIcon color="primary" /></ListItemIcon>
                  <ListItemText primary="Guía de Remisión Remitente" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('guiaTransportista')}>
                  <ListItemIcon><LocalShippingIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Guía de Remisión Transportista" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('plantillasPdf')}>
                  <ListItemIcon><DocumentScannerIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Plantillas PDF" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('adminVentas')}>
                  <ListItemIcon><ReceiptIcon color="warning" /></ListItemIcon>
                  <ListItemText primary="Centro de Ventas" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('ventaRapida')}>
                  <ListItemIcon><PointOfSaleIcon color="primary" /></ListItemIcon>
                  <ListItemText primary="Venta Rápida" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('sire_ventas')}>
                  <ListItemIcon><ReceiptIcon color="success" /></ListItemIcon>
                  <ListItemText primary="SIRE Ventas" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('sire_ventas_declaracion')}>
                  <ListItemIcon><ReceiptIcon color="primary" /></ListItemIcon>
                  <ListItemText primary="SIRE Ventas Declaración" />
                </ListItem>
              </List>
            </Collapse>
          </>)}
          {/* LOGÍSTICA */}
          {tieneModulo('logistica') && (<>
            <ListItem button onClick={() => setOpenComprasMenu(!openComprasMenu)}>
              <ListItemIcon><ShoppingCartIcon color="warning" /></ListItemIcon>
              <ListItemText primary="Logística" primaryTypographyProps={{ fontWeight: 'bold' }} />
              {openComprasMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openComprasMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('requerimiento')}>
                  <ListItemIcon><DescriptionIcon color="warning" /></ListItemIcon>
                  <ListItemText primary="Requerimientos" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('orden_compra')}>
                  <ListItemIcon><ListAltIcon color="warning" /></ListItemIcon>
                  <ListItemText primary="Órdenes de Compra" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('compras')}>
                  <ListItemIcon><ShoppingCartIcon color="primary" /></ListItemIcon>
                  <ListItemText primary="Registro de Compras" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('nc_compra')}>
                  <ListItemIcon><ShoppingCartIcon color="error" /></ListItemIcon>
                  <ListItemText primary="NC de Compras" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('kardex')}>
                  <ListItemIcon><Inventory2Icon color="success" /></ListItemIcon>
                  <ListItemText primary="Kardex de Inventario" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('adminCompras')}>
                  <ListItemIcon><ShoppingCartIcon color="warning" /></ListItemIcon>
                  <ListItemText primary="Centro de Compras" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('sire_compras')}>
                  <ListItemIcon><ShoppingCartIcon color="success" /></ListItemIcon>
                  <ListItemText primary="SIRE Compras" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('sire_compras_declaracion')}>
                  <ListItemIcon><ShoppingCartIcon color="warning" /></ListItemIcon>
                  <ListItemText primary="SIRE Compras Declaración" />
                </ListItem>
              </List>
            </Collapse>
          </>)}
          {/* PRODUCCIÓN */}
          {tieneModulo('produccion') && (<>
            <ListItem button onClick={() => setOpenProduccionMenu(!openProduccionMenu)}>
              <ListItemIcon><FactoryIcon color="secondary" /></ListItemIcon>
              <ListItemText primary="Producción" primaryTypographyProps={{ fontWeight: 'bold' }} />
              {openProduccionMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openProduccionMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('recetas')}>
                  <ListItemIcon><ScienceIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Recetas / BOM" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('orden_produccion')}>
                  <ListItemIcon><FactoryIcon color="primary" /></ListItemIcon>
                  <ListItemText primary="Órdenes de Producción" />
                </ListItem>
              </List>
            </Collapse>
          </>)}
          {/* IMPORTACIÓN */}
          {tieneModulo('importacion') && (
            <ListItem button onClick={() => setPage('importacion')}>
              <ListItemIcon><LocalShippingIcon color="warning" /></ListItemIcon>
              <ListItemText primary="Importaciones" primaryTypographyProps={{ fontWeight: 'bold' }} />
            </ListItem>
          )}
          {/* ACTIVO FIJO */}
          {tieneModulo('activoFijo') && (
            <ListItem button onClick={() => setPage('cont_activos_fijos')}>
              <ListItemIcon><Inventory2Icon color="info" /></ListItemIcon>
              <ListItemText primary="Activos Fijos" primaryTypographyProps={{ fontWeight: 'bold' }} />
            </ListItem>
          )}
          {/* TESORERÍA */}
          {tieneModulo('tesoreria') && (
            <ListItem button onClick={() => setPage('tesoreria')}>
              <ListItemIcon><AccountBalanceWalletIcon color="info" /></ListItemIcon>
              <ListItemText primary="Tesorería" primaryTypographyProps={{ fontWeight: 'bold' }} />
            </ListItem>
          )}
          {/* CAJA CHICA */}
          {tieneModulo('cajaChica') && (
            <ListItem button onClick={() => setPage('caja_chica')}>
              <ListItemIcon><LocalAtmIcon color="warning" /></ListItemIcon>
              <ListItemText primary="Caja Chica" primaryTypographyProps={{ fontWeight: 'bold' }} />
            </ListItem>
          )}
          {/* CONTABILIDAD */}
          {tieneModulo('contabilidad') && (<>
            <ListItem button onClick={() => setOpenContabilidadMenu(!openContabilidadMenu)}>
              <ListItemIcon><AccountBalanceIcon color="secondary" /></ListItemIcon>
              <ListItemText primary="Contabilidad" primaryTypographyProps={{ fontWeight: 'bold' }} />
              {openContabilidadMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openContabilidadMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_seleccionar_empresa')}>
                  <ListItemIcon><BusinessIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Cambiar Empresa" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_dashboard')}>
                  <ListItemIcon><DashboardIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Dashboard Contable" />
                </ListItem>
                {esSuperAdmin && (
                  <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_empresas')}>
                    <ListItemIcon><BusinessIcon color="secondary" /></ListItemIcon>
                    <ListItemText primary="Empresas Contables" />
                  </ListItem>
                )}
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_plan')}>
                  <ListItemIcon><AccountTreeIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Plan de Cuentas" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_periodos')}>
                  <ListItemIcon><CalendarMonthIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Períodos Contables" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_asientos')}>
                  <ListItemIcon><ReceiptLongIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Asientos Contables" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_reportes')}>
                  <ListItemIcon><AssessmentIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Reportes Contables" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_asiento_rapido')}>
                  <ListItemIcon><AutoFixHighIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Asiento Rápido Config" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_ple')}>
                  <ListItemIcon><DescriptionIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Libros PLE SUNAT" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_cierre')}>
                  <ListItemIcon><LockIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Cierre Anual" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_reg_ventas')}>
                  <ListItemIcon><ReceiptLongIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Registro de Ventas" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_reg_compras')}>
                  <ListItemIcon><ShoppingCartIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Registro de Compras" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_arqueo')}>
                  <ListItemIcon><LocalAtmIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Arqueo de Caja" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_importar_sire')}>
                  <ListItemIcon><CloudDownloadIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Importar SIRE" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_centros_costo')}>
                  <ListItemIcon><AccountTreeIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Centros de Costo" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_conciliacion')}>
                  <ListItemIcon><AccountBalanceIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Conciliación Bancaria" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_activos_fijos')}>
                  <ListItemIcon><Inventory2Icon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Activos Fijos" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_presupuesto')}>
                  <ListItemIcon><AssessmentIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Presupuesto vs. Real" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_aging')}>
                  <ListItemIcon><AccountBalanceWalletIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Antigüedad de Saldos" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_retenciones')}>
                  <ListItemIcon><ReceiptLongIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Retenciones y Detracciones" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_pdt0621')}>
                  <ListItemIcon><AssessmentIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="PDT 0621 — IGV/Renta" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_analisis')}>
                  <ListItemIcon><ManageSearchIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Análisis de Cuenta" />
                </ListItem>
<ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_efc')}>
                  <ListItemIcon><AccountBalanceWalletIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Estado de Flujos de Efectivo" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_urc_clasificacion')}>
                  <ListItemIcon><LabelIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Clasificación URC (Retroactiva)" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_rubro_eeff')}>
                  <ListItemIcon><CategoryIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Clasificación de Rubros EEFF" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('cont_auxiliares')}>
                  <ListItemIcon><PeopleIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Auxiliares Contables" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('tipoCambio')}>
                  <ListItemIcon><CurrencyExchangeIcon color="secondary" /></ListItemIcon>
                  <ListItemText primary="Tipo de Cambio" />
                </ListItem>
              </List>
            </Collapse>
          </>)}
          {/* RR.HH. */}
          {tieneModulo('rrhh') && (<>
            <ListItem button onClick={() => setOpenRrhhMenu(!openRrhhMenu)}>
              <ListItemIcon><BadgeIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
              <ListItemText primary="Recursos Humanos" primaryTypographyProps={{ fontWeight: 'bold' }} />
              {openRrhhMenu ? <ExpandLess /> : <ExpandMore />}
            </ListItem>
            <Collapse in={openRrhhMenu} timeout="auto" unmountOnExit>
              <List component="div" disablePadding>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_dashboard')}>
                  <ListItemIcon><DashboardIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Dashboard RR.HH." />
                </ListItem>
                {esSuperAdmin && (
                  <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_empresas')}>
                    <ListItemIcon><BusinessIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                    <ListItemText primary="Empresas RRHH" />
                  </ListItem>
                )}
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_trabajadores')}>
                  <ListItemIcon><GroupsIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Trabajadores" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_planilla')}>
                  <ListItemIcon><ReceiptLongIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Planilla Mensual" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_cts')}>
                  <ListItemIcon><SavingsIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="CTS" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_gratificaciones')}>
                  <ListItemIcon><CardGiftcardIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Gratificaciones" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_vacaciones')}>
                  <ListItemIcon><BeachAccessIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Vacaciones" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_prestamos')}>
                  <ListItemIcon><AccountBalanceWalletIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Préstamos" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_adelantos')}>
                  <ListItemIcon><MoneyOffIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Adelantos" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_asistencia')}>
                  <ListItemIcon><AccessTimeIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Asistencia" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_feriados')}>
                  <ListItemIcon><CalendarMonthIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Feriados" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_seguro_vida')}>
                  <ListItemIcon><HealthAndSafetyIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Seguro de Vida" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_liquidacion')}>
                  <ListItemIcon><GavelIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Liquidación al Cese" />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_reportes')}>
                  <ListItemIcon><AssessmentIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Reportes RR.HH." />
                </ListItem>
                <ListItem button sx={{ pl: 4 }} onClick={() => setPage('rrhh_rxh')}>
                  <ListItemIcon><BadgeIcon sx={{ color: '#7b1fa2' }} /></ListItemIcon>
                  <ListItemText primary="Recibos por Honorarios" />
                </ListItem>
              </List>
            </Collapse>
          </>)}

          {/* UTILIDADES: Reimprimir XML + Manual */}
          <Box sx={{ mt: 'auto', pt: 1, borderTop: '1px solid', borderColor: 'divider' }}>
            <ListItem button onClick={() => setPage('reimprimirXml')}
              sx={{ borderRadius: 2, mx: 1, bgcolor: activePage === 'reimprimirXml' ? 'success.light' : 'transparent',
                    '&:hover': { bgcolor: 'success.light' } }}>
              <ListItemIcon>
                <DescriptionIcon sx={{ color: activePage === 'reimprimirXml' ? 'success.dark' : '#1a237e' }} />
              </ListItemIcon>
              <ListItemText primary="Reimprimir XML"
                primaryTypographyProps={{ fontWeight: 'bold', color: activePage === 'reimprimirXml' ? 'success.dark' : '#1a237e', fontSize: 14 }} />
            </ListItem>
            {esSuperAdmin && (
              <ListItem button onClick={() => setPage('controlComprobantes')}
                sx={{ borderRadius: 2, mx: 1, bgcolor: activePage === 'controlComprobantes' ? 'error.light' : 'transparent',
                      '&:hover': { bgcolor: 'error.light' } }}>
                <ListItemIcon>
                  <DescriptionIcon sx={{ color: activePage === 'controlComprobantes' ? 'error.dark' : '#1a237e' }} />
                </ListItemIcon>
                <ListItemText primary="Control de comprobantes"
                  primaryTypographyProps={{ fontWeight: 'bold', color: activePage === 'controlComprobantes' ? 'error.dark' : '#1a237e', fontSize: 14 }} />
              </ListItem>
            )}
            <ListItem button onClick={() => setPage('manual')}
              sx={{ borderRadius: 2, mx: 1, bgcolor: activePage === 'manual' ? 'primary.light' : 'transparent',
                    '&:hover': { bgcolor: 'primary.light' } }}>
              <ListItemIcon>
                <MenuBookIcon sx={{ color: activePage === 'manual' ? 'primary.dark' : '#1a237e' }} />
              </ListItemIcon>
              <ListItemText primary="Manual del Sistema"
                primaryTypographyProps={{ fontWeight: 'bold', color: activePage === 'manual' ? 'primary.dark' : '#1a237e', fontSize: 14 }} />
            </ListItem>
          </Box>
        </List>
      );
      if (isMobile) return (
        <>
          {/* Backdrop oscuro al tocar fuera */}
          <Box
            onClick={handleDrawer}
            sx={{
              display: open ? 'block' : 'none',
              position: 'fixed', inset: 0,
              bgcolor: 'rgba(0,0,0,0.45)',
              zIndex: 1200,
            }}
          />
          {/* Panel deslizante — sin Modal MUI → sin scroll lock → sin ancho extra */}
          <Box sx={{
            position: 'fixed', top: 0, left: 0,
            height: '100vh',
            width: 'min(280px, 88vw)',
            zIndex: 1201,
            bgcolor: 'background.paper',
            boxShadow: open ? '4px 0 24px rgba(0,0,0,0.18)' : 'none',
            transform: open ? 'translateX(0)' : 'translateX(-100%)',
            transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
            visibility: open ? 'visible' : 'hidden',
            overflowY: 'auto',
            overflowX: 'hidden',
          }}>
            {listContent}
          </Box>
        </>
      );
      return (
        <Drawer open={open} onClose={handleDrawer} PaperProps={{ sx: { maxWidth: '88vw', overflowX: 'hidden' } }}>
          {listContent}
        </Drawer>
      );
      })()}
      <Box component="main" sx={{ flexGrow: 1, minWidth: 0, p: { xs: 1, sm: 2, md: 3 }, pt: { xs: 9, sm: 10, md: 12 }, maxWidth: '100vw', margin: '0 auto', display: 'flex', flexDirection: 'column', alignItems: 'center' }}>
        {activePage === 'categorias' ? (
          <Categorias />
        ) : activePage === 'subcategorias' ? (
          <Subcategorias />
        ) : activePage === 'marcas' ? (
          <Marcas />
        ) : activePage === 'modelos' ? (
          <Modelos />
        ) : activePage === 'tallas' ? (
          <Tallas />
        ) : activePage === 'colores' ? (
          <Colores />
        ) : activePage === 'unidades' ? (
          <Unidades />
        ) : activePage === 'conversiones' ? (
          <Conversiones />
        ) : activePage === 'productos' ? (
          <Productos />
        ) : activePage === 'configWhatsApp' ? (
          <ConfiguracionWhatsApp />
        ) : activePage === 'configEmail' ? (
          <ConfiguracionEmail />
        ) : activePage === 'configEmpresa' && esSuperAdmin ? (
          <ConfiguracionEmpresa />
        ) : activePage === 'configEmpresa' ? (
          <Box sx={{ p: 4 }}>
            <Typography variant="h6" color="error">No tienes permisos para acceder a Configuración de Empresa.</Typography>
            <Typography variant="body2" color="text.secondary">Solo el administrador del sistema puede ver esta sección.</Typography>
          </Box>
        ) : activePage === 'ubigeoManager' ? (
          <UbigeoManager />
        ) : activePage === 'cotizaciones' ? (
          <CotizacionPage />
        ) : activePage === 'notaVenta' ? (
          <NotaVentaPage />
        ) : activePage === 'boleta' ? (
          <BoletaVentaPage />
        ) : activePage === 'factura' ? (
          <FacturaPage />
        ) : activePage === 'notaCredito' ? (
          <NotaCreditoPage />
        ) : activePage === 'notaDebito' ? (
          <NotadebitoPage />
        ) : activePage === 'guiaRemision' ? (
          <GuiaRemisionPage />
        ) : activePage === 'adminVentas' ? (
          <AdminVentasPage key="adminVentas" />
        ) : activePage === 'adminCompras' ? (
          <AdminComprasPage key="adminCompras" />
        ) : activePage === 'ventaRapida' ? (
          <VentaRapidaPage key="ventaRapida" />
        ) : activePage === 'guiaTransportista' ? (
          <GuiaRemisionTransportistaPage key="guiaTransportista" />
        ) : activePage === 'choferes' ? (
          <ChoferesPage key="choferes" />
        ) : activePage === 'vehiculos' ? (
          <VehiculosPage key="vehiculos" />
        ) : activePage === 'transportistas' ? (
          <TransportistasPage key="transportistas" />
        ) : activePage === 'requerimiento' ? (
          <RequerimientoPage key="requerimiento" />
        ) : activePage === 'recetas' ? (
          <RecetasPage key="recetas" />
        ) : activePage === 'orden_produccion' ? (
          <OrdenProduccionPage key="orden_produccion" />
        ) : activePage === 'importacion' ? (
          <ImportacionPage key="importacion" />
        ) : activePage === 'orden_compra' ? (
          <OrdenCompraPage key="orden_compra" />
        ) : activePage === 'compras' ? (
          <CompraPage key="compras" />
        ) : activePage === 'nc_compra' ? (
          <NotaCreditoCompraPage key="nc_compra" />
        ) : activePage === 'kardex' ? (
          <KardexPage key="kardex" />
        ) : activePage === 'tesoreria' ? (
          <TesoreriaPage key="tesoreria" />
        ) : activePage === 'caja_chica' ? (
          <CajaChicaPage key="caja_chica" />
        ) : activePage === 'cont_empresas' ? (
          <EmpresasContables key="cont_empresas" />
        ) : activePage === 'cont_plan' ? (
          <PlanContable key="cont_plan" />
        ) : activePage === 'cont_periodos' ? (
          <Periodos key="cont_periodos" />
        ) : activePage === 'cont_asientos' ? (
          <Asientos key="cont_asientos" abrirAsientoId={asientoAAbrir}
            onAsientoAbierto={() => setAsientoAAbrir(null)} />
        ) : activePage === 'cont_reportes' ? (
          <ReportesContables key="cont_reportes" onIrAAsiento={(id) => { setAsientoAAbrir(id); setPage('cont_asientos'); }} />
        ) : activePage === 'cont_asiento_rapido' ? (
          <AsientoRapidoConfig key="cont_asiento_rapido" />
        ) : activePage === 'sire_ventas' ? (
          <SireVentas key="sire_ventas" />
        ) : activePage === 'sire_compras' ? (
          <SireCompras key="sire_compras" />
        ) : activePage === 'sire_ventas_declaracion' ? (
          <SireVentasDeclaracion key="sire_ventas_declaracion" />
        ) : activePage === 'sire_compras_declaracion' ? (
          <SireComprasDeclaracion key="sire_compras_declaracion" />
        ) : activePage === 'cont_ple' ? (
          <Ple key="cont_ple" />
        ) : activePage === 'cont_cierre' ? (
          <CierreContable key="cont_cierre" />
        ) : activePage === 'cont_reg_ventas' ? (
          <RegistroVentas key="cont_reg_ventas" />
        ) : activePage === 'cont_reg_compras' ? (
          <RegistroCompras key="cont_reg_compras" />
        ) : activePage === 'cont_arqueo' ? (
          <ArqueoCaja key="cont_arqueo" />
        ) : activePage === 'cont_importar_sire' ? (
          <ImportadorSire key="cont_importar_sire" />
        ) : activePage === 'cont_centros_costo' ? (
          <CentrosCosto key="cont_centros_costo" />
        ) : activePage === 'cont_conciliacion' ? (
          <ConciliacionBancaria key="cont_conciliacion" />
        ) : activePage === 'cont_activos_fijos' ? (
          <ActivosFijos key="cont_activos_fijos" />
        ) : activePage === 'cont_presupuesto' ? (
          <Presupuesto key="cont_presupuesto" />
        ) : activePage === 'cont_aging' ? (
          <AgingCuentas key="cont_aging" />
        ) : activePage === 'cont_retenciones' ? (
          <Retenciones key="cont_retenciones" />
        ) : activePage === 'cont_dashboard' ? (
          <DashboardContable key="cont_dashboard" />
        ) : activePage === 'cont_seleccionar_empresa' ? (
          <SeleccionarEmpresaContable key="cont_seleccionar_empresa" onSelected={() => setPage('cont_dashboard')} />
        ) : activePage === 'cont_pdt0621' ? (
          <Pdt0621 key="cont_pdt0621" />
        ) : activePage === 'cont_analisis' ? (
          <AnalisisCuenta key="cont_analisis" />
        ) : activePage === 'cont_efc' ? (
          <EstadoFlujosCash key="cont_efc" />
        ) : activePage === 'cont_urc_clasificacion' ? (
          <UrcClasificacion key="cont_urc_clasificacion" />
        ) : activePage === 'cont_rubro_eeff' ? (
          <RubroEeffClasificacion key="cont_rubro_eeff" />
        ) : activePage === 'cont_auxiliares' ? (
          <AuxiliaresContable key="cont_auxiliares" />
        ) : activePage === 'rrhh_dashboard' ? (
          <DashboardRRHH key="rrhh_dashboard" />
        ) : activePage === 'rrhh_empresas' ? (
          <EmpresasRRHH key="rrhh_empresas" />
        ) : activePage === 'rrhh_trabajadores' ? (
          <TrabajadoresPage key="rrhh_trabajadores" />
        ) : activePage === 'rrhh_planilla' ? (
          <PlanillaRRHH key="rrhh_planilla" />
        ) : activePage === 'rrhh_cts' ? (
          <CtsPage key="rrhh_cts" />
        ) : activePage === 'rrhh_gratificaciones' ? (
          <GratificacionesPage key="rrhh_gratificaciones" />
        ) : activePage === 'rrhh_vacaciones' ? (
          <VacacionesPage key="rrhh_vacaciones" />
        ) : activePage === 'rrhh_prestamos' ? (
          <PrestamosPage key="rrhh_prestamos" />
        ) : activePage === 'rrhh_adelantos' ? (
          <AdelantosPage key="rrhh_adelantos" />
        ) : activePage === 'rrhh_asistencia' ? (
          <AsistenciaPage key="rrhh_asistencia" />
        ) : activePage === 'rrhh_feriados' ? (
          <FeriadosPage key="rrhh_feriados" />
        ) : activePage === 'rrhh_seguro_vida' ? (
          <SeguroVidaPage key="rrhh_seguro_vida" />
        ) : activePage === 'rrhh_liquidacion' ? (
          <LiquidacionPage key="rrhh_liquidacion" />
        ) : activePage === 'rrhh_reportes' ? (
          <ReportesRRHH key="rrhh_reportes" />
        ) : activePage === 'rrhh_rxh' ? (
          <RxhPage key="rrhh_rxh" />
        ) : activePage === 'plantillasPdf' ? (
          <PlantillasPdf />
        ) : activePage === 'sucursales' ? (
          <Sucursales />
        ) : activePage === 'seriesSucursal' ? (
          <SeriesSucursal />
        ) : activePage === 'usuarios' ? (
          <Usuarios />
        ) : activePage === 'permisosUsuario' ? (
          <PermisosUsuario />
        ) : activePage === 'series' ? (
          <Series />
        ) : activePage === 'tipoDocumento' ? (
          <TipoDocumento />
        ) : activePage === 'tipoDocIdentidad' ? (
          <TipoDocumentoIdentidad />
        ) : activePage === 'auxiliares' ? (
          <Auxiliares />
        ) : activePage === 'tipoCambio' ? (
          <TipoCambio />
        ) : activePage === 'condicionPago' ? (
          <CondicionPago />
        ) : activePage === 'almacenes' ? (
          <Almacenes />
        ) : activePage === 'reimprimirXml' ? (
          <ReimprimirXmlPage key="reimprimirXml" />
        ) : activePage === 'manual' ? (
          <ManualPage key="manual" />
        ) : activePage === 'controlComprobantes' && esSuperAdmin ? (
          <ControlComprobantes key="controlComprobantes" />
        ) : !mostrarPanelInicio ? (
          <PanelInicioBienvenida
            logoEmpresa={logoEmpresa}
            nombreUsuario={nombreUsuarioActual}
            secciones={seccionesAccesoDirecto}
            onNavigate={setPage}
          />
        ) : (
          <>
            <Box sx={{ width: '100%', maxWidth: 1450 }}>
              <Box sx={{ display: 'flex', flexDirection: { xs: 'column', sm: 'row' }, justifyContent: 'space-between', alignItems: { xs: 'flex-start', sm: 'center' }, gap: { xs: 1.5, sm: 2 }, mb: 2 }}>
                <Box>
                  <Typography variant="h4" sx={{ fontWeight: 800, color: '#12324a', fontSize: { xs: '1.5rem', sm: '2.125rem' } }}>Panel Comercial</Typography>
                  <Typography variant="body1" color="text.secondary" sx={{ display: { xs: 'none', sm: 'block' } }}>
                    Ventas reales, estado operativo CPE y espacio reservado para integrar compras sin rediseñar el tablero.
                  </Typography>
                </Box>
                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={1} alignItems={{ xs: 'stretch', sm: 'center' }}>
                  <Chip label={`Año actual: ${formatCurrency(dashboardData.resumen.ventasAnioActual)}`} color="primary" variant="outlined" sx={{ display: { xs: 'none', sm: 'flex' } }} />
                  <Button variant="contained" onClick={cargarDashboard} disabled={dashboardLoading} sx={{ width: { xs: '100%', sm: 'auto' } }}>
                    {dashboardLoading ? 'Actualizando...' : (isMobile ? 'Actualizar' : 'Actualizar dashboard')}
                  </Button>
                </Stack>
              </Box>

              {dashboardError && (
                <Alert severity="error" sx={{ mb: 2 }}>
                  {dashboardError}
                </Alert>
              )}

              {dashboardLoading ? (
                <Card sx={{ borderRadius: 3, boxShadow: 4, p: 4, mb: 3 }}>
                  <Stack spacing={2} alignItems="center">
                    <CircularProgress />
                    <Typography variant="body1" color="text.secondary">
                      Cargando métricas reales de ventas...
                    </Typography>
                  </Stack>
                </Card>
              ) : (
                <>
                  {/* ── Row 1: 4 KPI Cards ────────────────────────────── */}
                  <Grid container spacing={{ xs: 1, sm: 2 }} sx={{ mb: 2 }}>
                    {[
                      {
                        label: 'Ventas del Mes', icon: '📈',
                        value: formatCurrency(dashboardData.resumen.ventasMesActual),
                        sub: `${dashboardData.resumen.variacionMensual >= 0 ? '▲' : '▼'} ${Math.abs(Number(dashboardData.resumen.variacionMensual||0)).toFixed(1)}% vs mes anterior`,
                        subColor: dashboardData.resumen.variacionMensual >= 0 ? '#a5f3a5' : '#fca5a5',
                        grad: 'linear-gradient(135deg, #0d47a1 0%, #1565c0 100%)'
                      },
                      {
                        label: 'Compras del Mes', icon: '🛒',
                        value: formatCurrency(dashboardData.compras?.mesMonto || 0),
                        sub: `${formatNumber(dashboardData.compras?.mesCount || 0)} documentos`,
                        subColor: '#fde68a',
                        grad: 'linear-gradient(135deg, #1a3c5a 0%, #1e5c8a 100%)'
                      },
                      {
                        label: 'Balance Tesorería', icon: '⚖️',
                        value: formatCurrency(Math.abs(dashboardData.tesoreria?.balance || 0)),
                        sub: (dashboardData.tesoreria?.balance || 0) >= 0 ? '✅ Saldo positivo (Cobros > Pagos)' : '⚠️ Saldo negativo (Pagos > Cobros)',
                        subColor: (dashboardData.tesoreria?.balance || 0) >= 0 ? '#a5f3a5' : '#fca5a5',
                        grad: (dashboardData.tesoreria?.balance || 0) >= 0 ? 'linear-gradient(135deg, #1b5e20 0%, #2e7d32 100%)' : 'linear-gradient(135deg, #7f1d1d 0%, #b91c1c 100%)'
                      },
                      {
                        label: 'Ticket Promedio', icon: '🎫',
                        value: formatCurrency(dashboardData.resumen.ticketPromedioMesActual),
                        sub: `${formatNumber(dashboardData.resumen.comprobantesMesActual)} comprobantes`,
                        subColor: '#c4b5fd',
                        grad: 'linear-gradient(135deg, #4527a0 0%, #673ab7 100%)'
                      },
                    ].map((card, i) => (
                      <Grid item xs={6} sm={6} md={3} key={i}>
                        <Paper elevation={4} sx={{
                          background: card.grad, borderRadius: 3, p: { xs: 1.5, sm: 2.5 }, color: '#fff',
                          transition: 'transform 0.2s, box-shadow 0.2s',
                          '&:hover': { transform: 'translateY(-3px)', boxShadow: 8 }
                        }}>
                          <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start' }}>
                            <Typography variant="body2" sx={{ opacity: 0.85, fontWeight: 600, mb: 0.5, fontSize: { xs: '0.7rem', sm: '0.875rem' } }}>{card.label}</Typography>
                            <Typography sx={{ fontSize: { xs: 18, sm: 24 } }}>{card.icon}</Typography>
                          </Box>
                          <Typography variant="h4" fontWeight={800} sx={{ my: 0.5, fontSize: { xs: '1.2rem', sm: '1.75rem', md: '2.125rem' } }}>{card.value}</Typography>
                          <Typography variant="caption" sx={{ color: card.subColor, fontWeight: 600, fontSize: { xs: '0.6rem', sm: '0.75rem' } }}>{card.sub}</Typography>
                        </Paper>
                      </Grid>
                    ))}
                  </Grid>

                  {/* ── Accesos Rápidos (solo móvil) ─────────────────── */}
                  {isMobile && (
                    <Box sx={{ mb: 2 }}>
                      <Typography variant="caption" fontWeight={700} color="text.secondary" sx={{ mb: 1, display: 'block', textTransform: 'uppercase', letterSpacing: '0.6px', fontSize: '0.62rem' }}>
                        Accesos rápidos
                      </Typography>
                      <Grid container spacing={1.5}>
                        {[
                          { label: 'Venta Rápida', icon: <PointOfSaleIcon sx={{ fontSize: 26 }} />, page: 'ventaRapida', modulo: 'facturacion', color: '#1565c0', bg: '#e3f2fd' },
                          { label: 'Factura', icon: <ReceiptIcon sx={{ fontSize: 26 }} />, page: 'factura', modulo: 'facturacion', color: '#2e7d32', bg: '#e8f5e9' },
                          { label: 'Boleta', icon: <ReceiptLongIcon sx={{ fontSize: 26 }} />, page: 'boleta', modulo: 'facturacion', color: '#00695c', bg: '#e0f2f1' },
                          { label: 'Compras', icon: <ShoppingCartIcon sx={{ fontSize: 26 }} />, page: 'compras', modulo: 'logistica', color: '#e65100', bg: '#fff3e0' },
                          { label: 'Kardex', icon: <Inventory2Icon sx={{ fontSize: 26 }} />, page: 'kardex', modulo: 'logistica', color: '#6a1b9a', bg: '#f3e5f5' },
                          { label: 'Tesorería', icon: <AccountBalanceWalletIcon sx={{ fontSize: 26 }} />, page: 'tesoreria', modulo: 'tesoreria', color: '#0277bd', bg: '#e1f5fe' },
                        ].filter(item => tieneModulo(item.modulo)).map(item => (
                          <Grid
                            item
                            xs={4}
                            key={item.page}
                            sx={{
                              flexBasis: '33.333% !important',
                              maxWidth: '33.333% !important',
                              width: '33.333% !important',
                              minWidth: '0 !important',
                            }}
                          >
                            <Paper
                              onClick={() => setPage(item.page)}
                              elevation={0}
                              sx={{
                                display: 'flex', flexDirection: 'column', alignItems: 'center',
                                justifyContent: 'center', p: 1.5, gap: 0.5,
                                bgcolor: item.bg, borderRadius: 2.5, cursor: 'pointer',
                                border: '1.5px solid', borderColor: `${item.color}28`,
                                transition: 'transform 0.12s',
                                '&:active': { transform: 'scale(0.93)' },
                                minHeight: 78,
                              }}
                            >
                              <Box sx={{ color: item.color }}>{item.icon}</Box>
                              <Typography variant="caption" fontWeight={700} color={item.color} textAlign="center" sx={{ fontSize: '0.68rem', lineHeight: 1.2 }}>
                                {item.label}
                              </Typography>
                            </Paper>
                          </Grid>
                        ))}
                      </Grid>
                    </Box>
                  )}

                  {/* ── Row 2: Ventas mensuales (full width) ──────────── */}
                  <Paper elevation={2} sx={{ p: 2, mb: 2, borderRadius: 2, maxWidth: '100%', overflow: 'hidden', boxSizing: 'border-box' }}>
                    <Typography variant="subtitle1" fontWeight={700} color="primary.dark" sx={{ mb: 1 }}>
                      📊 Ventas mensuales — Últimos 6 meses
                    </Typography>
                    <ResponsiveContainer width="100%" height={isMobile ? 140 : 200}>
                      <BarChart data={ventasMensuales} margin={{ top: 5, right: 20, left: 10, bottom: 5 }}>
                        <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                        <XAxis dataKey="periodo" tick={{ fontSize: 12 }} />
                        <YAxis tickFormatter={v => currencyFormatter.format(v)} tick={{ fontSize: 11 }} width={90} />
                        <Tooltip formatter={v => [currencyFormatter.format(v), 'Total']} />
                        <Bar dataKey="total" fill="#1565c0" radius={[4,4,0,0]} name="Total" />
                      </BarChart>
                    </ResponsiveContainer>
                  </Paper>

                  {/* ── Row 3: 3 charts ──────────────────────────────── */}
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={4}>
                      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, height: 250 }}>
                        <Typography variant="subtitle2" fontWeight={700} color="primary.dark" sx={{ mb: 1 }}>Documentos por tipo</Typography>
                        <ResponsiveContainer width="100%" height={200}>
                          <BarChart data={documentosPorTipo} layout="vertical" margin={{ left: 10 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={false} />
                            <XAxis type="number" tick={{ fontSize: 11 }} />
                            <YAxis dataKey="tipo" type="category" tick={{ fontSize: 11 }} width={75} />
                            <Tooltip />
                            <Bar dataKey="cantidad" fill="#0891b2" radius={[0,4,4,0]} name="Documentos" />
                          </BarChart>
                        </ResponsiveContainer>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, height: 250 }}>
                        <Typography variant="subtitle2" fontWeight={700} color="primary.dark" sx={{ mb: 1 }}>Top 5 Clientes (S/)</Typography>
                        <ResponsiveContainer width="100%" height={200}>
                          <BarChart data={topClientes.slice(0,5)} layout="vertical" margin={{ left: 10 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" horizontal={false} />
                            <XAxis type="number" tickFormatter={v => currencyFormatter.format(v)} tick={{ fontSize: 10 }} />
                            <YAxis dataKey="clienteCorto" type="category" tick={{ fontSize: 10 }} width={80} />
                            <Tooltip formatter={v => [currencyFormatter.format(v), 'Total']} />
                            <Bar dataKey="total" fill="#7c3aed" radius={[0,4,4,0]} name="Total (S/)" />
                          </BarChart>
                        </ResponsiveContainer>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={4}>
                      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, height: 250 }}>
                        <Typography variant="subtitle2" fontWeight={700} color="primary.dark" sx={{ mb: 1 }}>Estado CPE (SUNAT)</Typography>
                        <ResponsiveContainer width="100%" height={200}>
                          <BarChart data={estadosSunat} margin={{ left: 5 }}>
                            <CartesianGrid strokeDasharray="3 3" stroke="#f0f0f0" />
                            <XAxis dataKey="estado" tick={{ fontSize: 10 }} />
                            <YAxis tick={{ fontSize: 11 }} />
                            <Tooltip />
                            <Bar dataKey="cantidad" radius={[4,4,0,0]} name="Documentos">
                              {estadosSunat.map((entry, index) => (
                                <rect key={index} fill={entry.fill} />
                              ))}
                            </Bar>
                          </BarChart>
                        </ResponsiveContainer>
                      </Paper>
                    </Grid>
                  </Grid>

                  {/* ── Row 4: Tesorería + Compras widgets ─────────────── */}
                  <Grid container spacing={2} sx={{ mb: 2 }}>
                    <Grid item xs={12} md={6} sx={{ flexBasis: { xs: '100% !important', md: '50% !important' }, maxWidth: { xs: '100% !important', md: '50% !important' }, width: { xs: '100% !important', md: '50% !important' }, minWidth: '0 !important' }}>
                      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, borderLeft: '4px solid', borderColor: 'success.main', maxWidth: '100%', overflow: 'hidden', boxSizing: 'border-box' }}>
                        <Typography variant="subtitle2" fontWeight={700} color="primary.dark" sx={{ mb: 1.5 }}>
                          💰 Tesorería — Balance global
                        </Typography>
                        <Grid container spacing={1}>
                          {[
                            { label: 'Cobros pendientes', value: formatCurrency(dashboardData.tesoreria?.cobros_pendientes||0), count: `${dashboardData.tesoreria?.cobros_count||0} docs`, color: 'success.dark' },
                            { label: 'Pagos pendientes', value: formatCurrency(dashboardData.tesoreria?.pagos_pendientes||0), count: `${dashboardData.tesoreria?.pagos_count||0} docs`, color: 'error.dark' },
                            { label: 'Total cobrado', value: formatCurrency(dashboardData.tesoreria?.cobros_cobrados||0), count: 'Histórico', color: 'info.dark' },
                            { label: 'Balance neto', value: formatCurrency(Math.abs(dashboardData.tesoreria?.balance||0)), count: (dashboardData.tesoreria?.balance||0)>=0?'✅ Positivo':'⚠️ Negativo', color: (dashboardData.tesoreria?.balance||0)>=0?'success.dark':'error.dark' },
                          ].map((item, i) => (
                            <Grid
                              item
                              xs={6}
                              key={i}
                              sx={{
                                flexBasis: '50% !important',
                                maxWidth: '50% !important',
                                width: '50% !important',
                                minWidth: '0 !important',
                              }}
                            >
                              <Box sx={{ bgcolor: 'grey.50', borderRadius: 1, p: 1 }}>
                                <Typography variant="caption" color="text.secondary">{item.label}</Typography>
                                <Typography variant="body1" fontWeight={700} color={item.color}>{item.value}</Typography>
                                <Typography variant="caption" color="text.secondary">{item.count}</Typography>
                              </Box>
                            </Grid>
                          ))}
                        </Grid>
                      </Paper>
                    </Grid>
                    <Grid item xs={12} md={6}>
                      <Paper elevation={2} sx={{ p: 2, borderRadius: 2, borderLeft: '4px solid', borderColor: 'warning.main' }}>
                        <Typography variant="subtitle2" fontWeight={700} color="primary.dark" sx={{ mb: 1.5 }}>
                          🛒 Compras del mes
                        </Typography>
                        <Box sx={{ display: 'flex', gap: 2, alignItems: 'center', mb: 1.5 }}>
                          <Box sx={{ flex: 1, bgcolor: 'grey.50', borderRadius: 1, p: 1.5, textAlign: 'center' }}>
                            <Typography variant="caption" color="text.secondary">Monto total</Typography>
                            <Typography variant="h5" fontWeight={800} color="primary.dark">{formatCurrency(dashboardData.compras?.mesMonto||0)}</Typography>
                          </Box>
                          <Box sx={{ flex: 1, bgcolor: 'grey.50', borderRadius: 1, p: 1.5, textAlign: 'center' }}>
                            <Typography variant="caption" color="text.secondary">Documentos</Typography>
                            <Typography variant="h5" fontWeight={800} color="warning.dark">{formatNumber(dashboardData.compras?.mesCount||0)}</Typography>
                          </Box>
                        </Box>
                        <Chip label={`Compras registradas este mes`} size="small" color="warning" variant="outlined" icon={<span>🗓️</span>} />
                      </Paper>
                    </Grid>
                  </Grid>

                  <Grid container spacing={3} ref={explorationSectionRef}>
                    <Grid
                      item
                      xs={12}
                      xl={8}
                      sx={{
                        flexBasis: { xs: '100% !important', xl: '66.667% !important' },
                        maxWidth: { xs: '100% !important', xl: '66.667% !important' },
                        width: { xs: '100% !important', xl: '66.667% !important' },
                        minWidth: '0 !important',
                      }}
                    >
                      <Card sx={{ borderRadius: 3, boxShadow: 4, minHeight: { xs: 'unset', xl: 500 }, maxWidth: '100%', overflow: 'hidden' }}>
                        <CardContent sx={{ maxWidth: '100%', overflow: 'hidden' }}>
                          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                            Centro de Exploración Comercial
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Clic en tarjetas superiores para navegar insights. Esta sección está pensada para uso operativo y gerencial.
                          </Typography>

                          <Tabs
                            value={activeInsight}
                            onChange={(_, value) => setActiveInsight(value)}
                            variant="scrollable"
                            scrollButtons="auto"
                            sx={{ maxWidth: '100%', mb: 2.5 }}
                          >
                            <Tab value="ventasMes" label="Tendencia diaria" />
                            <Tab value="clientes" label="Clientes 360" />
                            <Tab value="ticket" label="Productos top" />
                            <Tab value="embudo" label="Embudo comercial" />
                            <Tab value="sunat" label="Rendimiento vendedores" />
                            <Tab value="roadmap" label="Roadmap módulos" />
                          </Tabs>

                          {activeInsight === 'ventasMes' && (
                            <ResponsiveContainer width="100%" height={340}>
                              <LineChart data={ventasDiarias} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="fechaCorta" hide />
                                <YAxis tickFormatter={(value) => formatNumber(value)} />
                                <Tooltip formatter={(value) => formatCurrency(value)} labelFormatter={(label, payload) => payload?.[0]?.payload?.fechaCorta || label} />
                                <Legend />
                                <Line type="monotone" dataKey="total" name="Venta neta diaria" stroke="#1565c0" strokeWidth={3} dot={false} />
                              </LineChart>
                            </ResponsiveContainer>
                          )}

                          {activeInsight === 'clientes' && (
                            <Grid container spacing={2}>
                              <Grid item xs={12} lg={7}>
                                <Box sx={{ overflowX: 'auto' }}>
                                <TableContainer component={Paper} variant="outlined">
                                  <Table size="small">
                                    <TableHead>
                                      <TableRow>
                                        <TableCell>Cliente</TableCell>
                                        <TableCell align="right">Documentos</TableCell>
                                        <TableCell align="right">Ticket Prom.</TableCell>
                                        <TableCell align="right">Total</TableCell>
                                        <TableCell align="right">Última compra</TableCell>
                                      </TableRow>
                                    </TableHead>
                                    <TableBody>
                                      {clientesExploracion.length === 0 && (
                                        <TableRow>
                                          <TableCell colSpan={5} align="center">Sin datos de clientes para el período.</TableCell>
                                        </TableRow>
                                      )}
                                      {clientesExploracion.map((cliente) => (
                                        <TableRow
                                          key={`${cliente.clienteId}-${cliente.cliente}`}
                                          hover
                                          onClick={() => cargarDetalleCliente(cliente.clienteId)}
                                          selected={Number(clienteDetalle.clienteId) === Number(cliente.clienteId)}
                                          sx={{ cursor: 'pointer' }}
                                        >
                                          <TableCell>{cliente.cliente}</TableCell>
                                          <TableCell align="right">{formatNumber(cliente.documentos)}</TableCell>
                                          <TableCell align="right">{formatCurrency(cliente.ticketPromedio)}</TableCell>
                                          <TableCell align="right">{formatCurrency(cliente.total)}</TableCell>
                                          <TableCell align="right">{formatDateShort(cliente.ultimaCompra)}</TableCell>
                                        </TableRow>
                                      ))}
                                    </TableBody>
                                  </Table>
                                </TableContainer>
                                </Box>
                              </Grid>
                              <Grid item xs={12} lg={5}>
                                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2, minHeight: 320 }}>
                                  <Typography variant="subtitle1" sx={{ fontWeight: 700, mb: 1 }}>
                                    Detalle del Cliente
                                  </Typography>
                                  {!clienteDetalle.clienteId && !clienteDetalleLoading && (
                                    <Typography variant="body2" color="text.secondary">
                                      Haz clic en un cliente para ver qué compró y sus últimas operaciones.
                                    </Typography>
                                  )}
                                  {clienteDetalleError && (
                                    <Alert severity="error" sx={{ mb: 1 }}>{clienteDetalleError}</Alert>
                                  )}
                                  {clienteDetalleLoading && (
                                    <Stack spacing={1} alignItems="center" sx={{ py: 3 }}>
                                      <CircularProgress size={24} />
                                      <Typography variant="body2" color="text.secondary">Cargando detalle del cliente...</Typography>
                                    </Stack>
                                  )}
                                  {clienteDetalle.clienteId && !clienteDetalleLoading && (
                                    <>
                                      <Typography variant="body1" sx={{ fontWeight: 700 }}>{clienteDetalle.cliente}</Typography>
                                      <Typography variant="caption" color="text.secondary">Doc: {clienteDetalle.numeroDocumento || '-'}</Typography>
                                      <Box sx={{ display: 'flex', gap: 1, flexWrap: 'wrap', mt: 1, mb: 1.5 }}>
                                        <Chip size="small" label={`Docs: ${formatNumber(clienteDetalle.resumen.documentos)}`} />
                                        <Chip size="small" label={`Ticket: ${formatCurrency(clienteDetalle.resumen.ticketPromedio)}`} />
                                        <Chip size="small" label={`Total: ${formatCurrency(clienteDetalle.resumen.total)}`} color="primary" />
                                      </Box>

                                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.8 }}>Top productos</Typography>
                                      <Stack spacing={0.8} sx={{ mb: 1.5 }}>
                                        {(clienteDetalle.topProductos || []).slice(0, 5).map((producto) => (
                                          <Box key={`${clienteDetalle.clienteId}-${producto.producto}`} sx={{ border: '1px solid #eef1f5', borderRadius: 1.5, p: 1 }}>
                                            <Typography variant="body2" sx={{ fontWeight: 600 }}>{producto.producto}</Typography>
                                            <Typography variant="caption" color="text.secondary">
                                              {formatCurrency(producto.total)} / {formatNumber(producto.unidades)} und
                                            </Typography>
                                          </Box>
                                        ))}
                                        {(clienteDetalle.topProductos || []).length === 0 && (
                                          <Typography variant="caption" color="text.secondary">Sin productos para mostrar.</Typography>
                                        )}
                                      </Stack>

                                      <Typography variant="subtitle2" sx={{ fontWeight: 700, mb: 0.8 }}>Últimas operaciones</Typography>
                                      <Stack spacing={0.8}>
                                        {(clienteDetalle.operaciones || []).slice(0, 4).map((op) => (
                                          <Box key={`op-${op.id}`} sx={{ border: '1px solid #eef1f5', borderRadius: 1.5, p: 1 }}>
                                            <Typography variant="caption" color="text.secondary">
                                              {TIPO_COMPROBANTE_LABELS[op.tipoComprobante] || op.tipoComprobante} · {op.serie}-{String(op.numero || '').padStart(8, '0')}
                                            </Typography>
                                            <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
                                              <Typography variant="body2" sx={{ fontWeight: 700 }}>{formatCurrency(op.total)}</Typography>
                                              <Chip size="small" label={op.estadoCpe} />
                                            </Box>
                                          </Box>
                                        ))}
                                        {(clienteDetalle.operaciones || []).length === 0 && (
                                          <Typography variant="caption" color="text.secondary">Sin operaciones recientes.</Typography>
                                        )}
                                      </Stack>
                                    </>
                                  )}
                                </Paper>
                              </Grid>
                            </Grid>
                          )}

                          {activeInsight === 'ticket' && (
                            <ResponsiveContainer width="100%" height={340}>
                              <BarChart data={topProductos} margin={{ top: 20, right: 20, left: 0, bottom: 10 }}>
                                <CartesianGrid strokeDasharray="3 3" />
                                <XAxis dataKey="producto" hide />
                                <YAxis tickFormatter={(value) => formatNumber(value)} />
                                <Tooltip formatter={(value, name) => (name === 'Unidades' ? formatNumber(value) : formatCurrency(value))} />
                                <Legend />
                                <Bar dataKey="total" name="Venta neta" fill="#00897b" radius={[8, 8, 0, 0]} />
                                <Bar dataKey="unidades" name="Unidades" fill="#ff8f00" radius={[8, 8, 0, 0]} />
                              </BarChart>
                            </ResponsiveContainer>
                          )}

                          {activeInsight === 'embudo' && (
                            <Grid container spacing={2}>
                              <Grid item xs={12} sm={6}>
                                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                  <Typography variant="subtitle2" color="text.secondary">Cotizaciones mes</Typography>
                                  <Typography variant="h4" sx={{ fontWeight: 800 }}>{formatNumber(embudoExploracion.cotizaciones)}</Typography>
                                  <Typography variant="body2" color="text.secondary">Monto: {formatCurrency(embudoExploracion.montoCotizaciones)}</Typography>
                                </Paper>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                  <Typography variant="subtitle2" color="text.secondary">Notas de venta mes</Typography>
                                  <Typography variant="h4" sx={{ fontWeight: 800 }}>{formatNumber(embudoExploracion.notasVenta)}</Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    Conversión cotización→NV: {embudoExploracion.cotizaciones > 0 ? `${((embudoExploracion.notasVenta / embudoExploracion.cotizaciones) * 100).toFixed(1)}%` : '0%'}
                                  </Typography>
                                </Paper>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                  <Typography variant="subtitle2" color="text.secondary">Comprobantes mes</Typography>
                                  <Typography variant="h4" sx={{ fontWeight: 800 }}>{formatNumber(embudoExploracion.comprobantes)}</Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    Conversión NV→CPE: {embudoExploracion.notasVenta > 0 ? `${((embudoExploracion.comprobantes / embudoExploracion.notasVenta) * 100).toFixed(1)}%` : '0%'}
                                  </Typography>
                                </Paper>
                              </Grid>
                              <Grid item xs={12} sm={6}>
                                <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                  <Typography variant="subtitle2" color="text.secondary">Aceptados SUNAT mes</Typography>
                                  <Typography variant="h4" sx={{ fontWeight: 800 }}>{formatNumber(embudoExploracion.aceptadosSunat)}</Typography>
                                  <Typography variant="body2" color="text.secondary">
                                    Aceptación CPE: {embudoExploracion.comprobantes > 0 ? `${((embudoExploracion.aceptadosSunat / embudoExploracion.comprobantes) * 100).toFixed(1)}%` : '0%'}
                                  </Typography>
                                </Paper>
                              </Grid>
                            </Grid>
                          )}

                          {activeInsight === 'sunat' && (
                            <Box sx={{ overflowX: 'auto' }}>
                            <TableContainer component={Paper} variant="outlined">
                              <Table size="small">
                                <TableHead>
                                  <TableRow>
                                    <TableCell>Vendedor</TableCell>
                                    <TableCell align="right">Documentos</TableCell>
                                    <TableCell align="right">Ticket Prom.</TableCell>
                                    <TableCell align="right">Total</TableCell>
                                  </TableRow>
                                </TableHead>
                                <TableBody>
                                  {vendedoresExploracion.length === 0 && (
                                    <TableRow>
                                      <TableCell colSpan={4} align="center">Sin datos de vendedores para el período.</TableCell>
                                    </TableRow>
                                  )}
                                  {vendedoresExploracion.map((vendedor) => (
                                    <TableRow key={`${vendedor.vendedorId}-${vendedor.vendedor}`}>
                                      <TableCell>{vendedor.vendedor}</TableCell>
                                      <TableCell align="right">{formatNumber(vendedor.documentos)}</TableCell>
                                      <TableCell align="right">{formatCurrency(vendedor.ticketPromedio)}</TableCell>
                                      <TableCell align="right">{formatCurrency(vendedor.total)}</TableCell>
                                    </TableRow>
                                  ))}
                                </TableBody>
                              </Table>
                            </TableContainer>
                            </Box>
                          )}

                          {activeInsight === 'roadmap' && (
                            <>
                              <Tabs
                                value={activeRoadmap}
                                onChange={(_, value) => setActiveRoadmap(value)}
                                variant="scrollable"
                                scrollButtons="auto"
                                sx={{ mb: 2 }}
                              >
                                {roadmapModules.map((modulo) => (
                                  <Tab key={modulo.key} value={modulo.key} label={modulo.label} />
                                ))}
                              </Tabs>
                              {roadmapModules.map((modulo) => (
                                activeRoadmap === modulo.key && (
                                  <Paper key={modulo.key} variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
                                    <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>{modulo.label}</Typography>
                                    <Chip
                                      label={modulo.enabled ? 'Activo' : 'Próximamente'}
                                      color={modulo.enabled ? 'success' : 'default'}
                                      size="small"
                                      sx={{ mb: 1.5 }}
                                    />
                                    {modulo.key === 'compras' && <Typography variant="body2" color="text.secondary">Preparado para añadir costos, proveedores y rentabilidad por producto sin cambiar layout.</Typography>}
                                    {modulo.key === 'kardex' && <Typography variant="body2" color="text.secondary">Preparado para trazabilidad de movimientos, rotación y alertas de quiebre.</Typography>}
                                    {modulo.key === 'tesoreria' && <Typography variant="body2" color="text.secondary">Preparado para cuentas por cobrar/pagar, cancelaciones y flujo de caja operativo.</Typography>}
                                    {modulo.key === 'contabilidad' && <Typography variant="body2" color="text.secondary">Preparado para consolidación tributaria y reportes contables gerenciales.</Typography>}
                                  </Paper>
                                )
                              ))}
                            </>
                          )}
                        </CardContent>
                      </Card>
                    </Grid>

                    <Grid
                      item
                      xs={12}
                      xl={4}
                      sx={{
                        flexBasis: { xs: '100% !important', xl: '33.333% !important' },
                        maxWidth: { xs: '100% !important', xl: '33.333% !important' },
                        width: { xs: '100% !important', xl: '33.333% !important' },
                        minWidth: '0 !important',
                      }}
                    >
                      <Card sx={{ borderRadius: 3, boxShadow: 4, minHeight: { xs: 'unset', xl: 500 } }}>
                        <CardContent>
                          <Typography variant="h6" sx={{ fontWeight: 700, mb: 1 }}>
                            Resumen Ejecutivo
                          </Typography>
                          <Typography variant="body2" color="text.secondary" sx={{ mb: 2 }}>
                            Indicadores clave para dirección comercial y operación diaria.
                          </Typography>
                          <Stack spacing={1.2}>
                            <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                              <Typography variant="caption" color="text.secondary">Ventas año actual</Typography>
                              <Typography variant="h6" sx={{ fontWeight: 800 }}>{formatCurrency(dashboardData.resumen.ventasAnioActual)}</Typography>
                            </Paper>
                            <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                              <Typography variant="caption" color="text.secondary">Comprobantes mes</Typography>
                              <Typography variant="h6" sx={{ fontWeight: 800 }}>{formatNumber(dashboardData.resumen.comprobantesMesActual)}</Typography>
                            </Paper>
                            <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                              <Typography variant="caption" color="text.secondary">Top cliente (90 días)</Typography>
                              <Typography variant="body1" sx={{ fontWeight: 700 }}>
                                {topClientes[0]?.cliente || 'Sin datos'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {topClientes[0] ? formatCurrency(topClientes[0].total) : '-'}
                              </Typography>
                            </Paper>
                            <Paper variant="outlined" sx={{ p: 1.5, borderRadius: 2 }}>
                              <Typography variant="caption" color="text.secondary">Producto líder (90 días)</Typography>
                              <Typography variant="body1" sx={{ fontWeight: 700 }}>
                                {topProductos[0]?.producto || 'Sin datos'}
                              </Typography>
                              <Typography variant="caption" color="text.secondary">
                                {topProductos[0] ? `${formatCurrency(topProductos[0].total)} / ${formatNumber(topProductos[0].unidades)} und` : '-'}
                              </Typography>
                            </Paper>
                            <Alert severity="info">
                              Dashboard preparado para activar Compras, Kardex, Tesorería y Contabilidad como módulos enchufables.
                            </Alert>
                          </Stack>
                        </CardContent>
                      </Card>
                    </Grid>
                  </Grid>
                </>
              )}
            </Box>
          </>
        )}
      </Box>
    </Box>
  );
};

export default Dashboard;

